<template>
  <div class="ops-modern compact">
    <div class="nav-bar-operations">
      <img src="@/assets/logogruas.png" alt="HomePage" @click="backMainPanel" class="logo-button" />
    </div>

    <div></div>

    <div class="ops-shell">
      <!-- Tabs -->
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item">
          <a class="nav-link" :class="{ active: activeTab === 'tab1' }" href="#" @click.prevent="activeTab = 'tab1'">
            Remolque
          </a>
        </li>

        <li class="nav-item">
          <a class="nav-link" :class="{ active: activeTab === 'tab3' }" href="#" @click.prevent="activeTab = 'tab3'">
            Auxilio Vial
          </a>
        </li>

        <li class="nav-item">
          <a class="nav-link" :class="{ active: activeTab === 'tab2' }" href="#" @click.prevent="activeTab = 'tab2'">
            Montacargas
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :class="{ active: activeTab === 'tab8' }" href="#" @click.prevent="activeTab = 'tab8'">
            Industrial
          </a>
        </li>


        <li class="nav-item">
          <a class="nav-link" :class="{ active: activeTab === 'tab4' }" href="#" @click.prevent="activeTab = 'tab4'">
            Lote
          </a>
        </li>

        <li class="nav-item">
          <a class="nav-link" :class="{ active: activeTab === 'tab5' }" href="#" @click.prevent="activeTab = 'tab5'">
            Órdenes en proceso
          </a>
        </li>

        <li class="nav-item">
          <a class="nav-link" :class="{ active: activeTab === 'tab6' }" href="#" @click.prevent="activeTab = 'tab6'">
            Órdenes programadas
          </a>
        </li>

        <li class="nav-item">
          <a class="nav-link" :class="{ active: activeTab === 'tab7' }" href="#" @click.prevent="activeTab = 'tab7'">
            Órdenes en lote
          </a>
        </li>

      </ul>

      <div class="tab-content mt-3">
        <!-- ============ TAB 1: REMOLQUE ============ -->
        <div class="tab-pane" :class="{ active: activeTab === 'tab1' }" v-show="activeTab === 'tab1'">
          <div id="ContentForAssistance">
            <div class="text-operations card-strip">
              <h2>Órdenes de trabajo: {{ totalAssistanceStatusCounts }}</h2>
            </div>
            <div class="action-buttons">
              <button @click="globalfilters" v-show="canSearchAssistanceNotes" class="action-button">Maestro de búsqueda</button>
              <button @click="statusUnits" v-show="canViewStatusUnits" class="action-button">Ver estatus de unidades</button>
              <button @click="newOrder" v-show="canCreateOrder" class="action-button action-primary">Nueva orden</button>
              <button @click="rastreoUnidades" v-show="canViewMainMap" class="action-button">Rastreo unidades</button>
            </div>

            <!-- In process -->
            <div class="table-container card-wrap">
              <h2>Órdenes en proceso</h2>
              <table class="table table--route">
                <thead>
                  <tr>
                    <th>
                      ID
                      <button class="sort-btn" @click="toggleSort('assistance','note_number')">
                        <span v-if="isSorted('assistance','note_number')">{{ sortState.assistance.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Solicitud
                      <button class="sort-btn" @click="toggleSort('assistance','request_time')">
                        <span v-if="isSorted('assistance','request_time')">{{ sortState.assistance.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Cliente
                      <button class="sort-btn" @click="toggleSort('assistance','client')">
                        <span v-if="isSorted('assistance','client')">{{ sortState.assistance.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>Origen</th>
                    <th>Destino</th>
                    <th>
                      Inicio
                      <button class="sort-btn" @click="toggleSort('assistance','start_time')">
                        <span v-if="isSorted('assistance','start_time')">{{ sortState.assistance.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Contacto
                      <button class="sort-btn" @click="toggleSort('assistance','contact_time')">
                        <span v-if="isSorted('assistance','contact_time')">{{ sortState.assistance.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Unidad
                      <button class="sort-btn" @click="toggleSort('assistance','unit_id')">
                        <span v-if="isSorted('assistance','unit_id')">{{ sortState.assistance.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Operador
                      <button class="sort-btn" @click="toggleSort('assistance','operator_employee_ident')">
                        <span v-if="isSorted('assistance','operator_employee_ident')">{{ sortState.assistance.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Expediente
                      <button class="sort-btn" @click="toggleSort('assistance','file_number')">
                        <span v-if="isSorted('assistance','file_number')">{{ sortState.assistance.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>Capturista</th>
                    <th>
                      Tipo
                      <button class="sort-btn" @click="toggleSort('assistance','type')">
                        <span v-if="isSorted('assistance','type')">{{ sortState.assistance.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Estatus
                      <button class="sort-btn" @click="toggleSort('assistance','status')">
                        <span v-if="isSorted('assistance','status')">{{ sortState.assistance.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(order, index) in assistancePaginatedInProcessOrders" :key="index" :class="{ 'row-cancelado-glow': hasCanceladoInRow(order), 'row-insurer-pending-glow': isInsurerPendingRow(order), 'row-overdue-glow': isOverdueRow(order) }">
                    <td>
                      <span class="note-pill"
                            :style="{ '--eta': calculateGradient(order.request_time, order.expected_time, order.arrival_time) }"
                            @click="viewNoteDetails(order.type, order.note_ident)">
                        {{ order.note_number }}
                      </span>
                    </td>
                    <td>
                      {{ order.request_time.substring(8,10) }}/{{ order.request_time.substring(5,7) }}/{{ order.request_time.substring(0,4) }}
                      {{ order.request_time.substring(11,16) }}
                    </td>
                    <td>{{ order.client }}</td>
                    <td>{{ order.source.neighborhood }}, {{ order.source.city }}, {{ order.source.state }}</td>
                    <td>{{ order.destination.neighborhood }}, {{ order.destination.city }}, {{ order.destination.state }}</td>
                    <td>{{ order.start_time.substring(11,16) }}</td>
                    <td>{{ order.contact_time.substring(11,16) }}</td>
                    <td>{{ order.unit_id }}</td>
                    <td>{{ order.operator_employee_ident }}</td>
                    <td>{{ order.file_number }}</td>
                    <td>{{ order.data_entry_clerk }}</td>
                    <td>{{ order.type === 'Asistencia víal' ? 'Remolque' : order.type }}</td> 
                    <td>
                      <span v-if="order.status === 'Activo'" class="status status--ok">Activo</span>
                      <span v-else-if="order.status === 'Asignada'" class="status status--info">Asignada</span>
                      <span v-else-if="order.status === 'Cancelado'" class="status status--danger">Cancelado</span>
                      <span v-else-if="order.status === 'Programado'" class="status status--warn">Pendiente</span>
                      <span v-else-if="order.status === 'Completado'" class="status status--ok">Completado</span>
                      <span v-else class="status">{{ order.status }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="pagination-container">
                <button @click="prevPageAssistance" :disabled="assistanceCurrentPage === 1">
                  <img src="@/assets/angulo-izquierdo.png" alt="Previous Page" />
                </button>
                <span v-for="pageNumber in assistanceTotalInProcessPages"
                      :key="pageNumber"
                      @click="goToPageAssistance(pageNumber)"
                      :class="{ active: pageNumber === assistanceCurrentPage }">
                  {{ pageNumber }}
                </span>
                <button @click="nextPageAssistance" :disabled="assistanceCurrentPage >= assistanceTotalInProcessPages">
                  <img src="@/assets/angulo-derecho.png" alt="Next Page" />
                </button>
              </div>
            </div>

            <!-- Scheduled -->
            <div class="table-container card-wrap">
              <h2>Órdenes pendientes</h2>
              <table class="table table--route">
                <thead>
                  <tr>
                    <th>
                      ID
                      <button class="sort-btn" @click="toggleSort('assistanceScheduled','note_number')">
                        <span v-if="isSorted('assistanceScheduled','note_number')">{{ sortState.assistanceScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Solicitud
                      <button class="sort-btn" @click="toggleSort('assistanceScheduled','request_time')">
                        <span v-if="isSorted('assistanceScheduled','request_time')">{{ sortState.assistanceScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Cliente
                      <button class="sort-btn" @click="toggleSort('assistanceScheduled','client')">
                        <span v-if="isSorted('assistanceScheduled','client')">{{ sortState.assistanceScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>Origen</th>
                    <th>Destino</th>
                    <th>
                      Inicio
                      <button class="sort-btn" @click="toggleSort('assistanceScheduled','start_time')">
                        <span v-if="isSorted('assistanceScheduled','start_time')">{{ sortState.assistanceScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Contacto
                      <button class="sort-btn" @click="toggleSort('assistanceScheduled','contact_time')">
                        <span v-if="isSorted('assistanceScheduled','contact_time')">{{ sortState.assistanceScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Unidad
                      <button class="sort-btn" @click="toggleSort('assistanceScheduled','unit_id')">
                        <span v-if="isSorted('assistanceScheduled','unit_id')">{{ sortState.assistanceScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Operador
                      <button class="sort-btn" @click="toggleSort('assistanceScheduled','operator_employee_ident')">
                        <span v-if="isSorted('assistanceScheduled','operator_employee_ident')">{{ sortState.assistanceScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Expediente
                      <button class="sort-btn" @click="toggleSort('assistanceScheduled','file_number')">
                        <span v-if="isSorted('assistanceScheduled','file_number')">{{ sortState.assistanceScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>Capturista</th>
                    <th>
                      Tipo
                      <button class="sort-btn" @click="toggleSort('assistanceScheduled','type')">
                        <span v-if="isSorted('assistanceScheduled','type')">{{ sortState.assistanceScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Estatus
                      <button class="sort-btn" @click="toggleSort('assistanceScheduled','status')">
                        <span v-if="isSorted('assistanceScheduled','status')">{{ sortState.assistanceScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(order, index) in assistancePaginatedScheduledOrders" :key="index" :class="{ 'row-cancelado-glow': hasCanceladoInRow(order), 'row-insurer-pending-glow': isInsurerPendingRow(order), 'row-overdue-glow': isOverdueRow(order) }">
                    <td>
                      <span class="note-pill"
                            :style="{ '--eta': calculateGradient(order.request_time, order.expected_time, order.arrival_time) }"
                            @click="viewNoteDetails(order.type, order.note_ident)">
                        {{ order.note_number }}
                      </span>
                    </td>
                    <td>
                      {{ order.request_time.substring(8,10) }}/{{ order.request_time.substring(5,7) }}/{{ order.request_time.substring(0,4) }}
                      {{ order.request_time.substring(11,16) }}
                    </td>
                    <td>{{ order.client }}</td>
                    <td>{{ order.source.neighborhood }}, {{ order.source.city }}, {{ order.source.state }}</td>
                    <td>{{ order.destination.neighborhood }}, {{ order.destination.city }}, {{ order.destination.state }}</td>
                    <td>{{ order.start_time.substring(11,16) }}</td>
                    <td>{{ order.contact_time.substring(11,16) }}</td>
                    <td>{{ order.unit_id }}</td>
                    <td>{{ order.operator_employee_ident }}</td>
                    <td>{{ order.file_number }}</td>
                    <td>{{ order.data_entry_clerk }}</td>
                    <td>{{ order.type === 'Asistencia víal' ? 'Remolque' : order.type }}</td>
                    <td>
                      <span v-if="order.status === 'Activo'" class="status status--ok">Activo</span>
                      <span v-else-if="order.status === 'Asignada'" class="status status--info">Asignada</span>
                      <span v-else-if="order.status === 'Cancelado'" class="status status--danger">Cancelado</span>
                      <span v-else-if="order.status === 'Programado'" class="status status--warn">Pendiente</span>
                      <span v-else-if="order.status === 'Completado'" class="status status--ok">Completado</span>
                      <span v-else class="status">{{ order.status }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="pagination-container">
                <button @click="prevScheduledPageAssistance" :disabled="assistanceCurrentScheduledPage === 1">
                  <img src="@/assets/angulo-izquierdo.png" alt="Previous Page" />
                </button>
                <span v-for="pageNumberScheduled in assistanceTotalScheduledPages"
                      :key="pageNumberScheduled"
                      @click="goToScheduledPageAssistance(pageNumberScheduled)"
                      :class="{ active: pageNumberScheduled === assistanceCurrentScheduledPage }">
                  {{ pageNumberScheduled }}
                </span>
                <button @click="nextScheduledPageAssistance" :disabled="assistanceCurrentScheduledPage >= assistanceTotalScheduledPages">
                  <img src="@/assets/angulo-derecho.png" alt="Next Page" />
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- ============ TAB 3: AUXILIO VIAL ============ -->
        <div class="tab-pane" :class="{ active: activeTab === 'tab3' }" v-show="activeTab === 'tab3'">
          <div id="ContentForAuxiliar">
            <div class="text-operations card-strip">
              <h2>Órdenes de trabajo: {{ totalAuxiliarStatusCounts }}</h2>
            </div>
            <div class="action-buttons">
              <button @click="globalfilters" v-show="canSearchAssistanceNotes" class="action-button">Maestro de búsqueda</button>
              <button @click="statusUnits" v-show="canViewStatusUnits" class="action-button">Ver estatus de unidades</button>
              <button @click="newOrder" v-show="canCreateOrder" class="action-button action-primary">Nueva orden</button>
              <button @click="rastreoUnidades" v-show="canViewMainMap" class="action-button">Rastreo unidades</button>
            </div>

            <!-- In process -->
            <div class="table-container card-wrap">
              <h2>Órdenes en proceso</h2>
              <table class="table">
                <thead>
                  <tr>
                    <th>
                      ID
                      <button class="sort-btn" @click="toggleSort('auxiliar','note_number')">
                        <span v-if="isSorted('auxiliar','note_number')">{{ sortState.auxiliar.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Solicitud
                      <button class="sort-btn" @click="toggleSort('auxiliar','request_time')">
                        <span v-if="isSorted('auxiliar','request_time')">{{ sortState.auxiliar.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Cliente
                      <button class="sort-btn" @click="toggleSort('auxiliar','client')">
                        <span v-if="isSorted('auxiliar','client')">{{ sortState.auxiliar.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>Origen</th>
                    <th>Servicio</th>
                    <th>
                      Inicio
                      <button class="sort-btn" @click="toggleSort('auxiliar','start_time')">
                        <span v-if="isSorted('auxiliar','start_time')">{{ sortState.auxiliar.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Contacto
                      <button class="sort-btn" @click="toggleSort('auxiliar','contact_time')">
                        <span v-if="isSorted('auxiliar','contact_time')">{{ sortState.auxiliar.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Unidad
                      <button class="sort-btn" @click="toggleSort('auxiliar','unit_id')">
                        <span v-if="isSorted('auxiliar','unit_id')">{{ sortState.auxiliar.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Operador
                      <button class="sort-btn" @click="toggleSort('auxiliar','operator_employee_ident')">
                        <span v-if="isSorted('auxiliar','operator_employee_ident')">{{ sortState.auxiliar.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Expediente
                      <button class="sort-btn" @click="toggleSort('auxiliar','file_number')">
                        <span v-if="isSorted('auxiliar','file_number')">{{ sortState.auxiliar.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>Capturista</th>
                    <th>
                      Tipo
                      <button class="sort-btn" @click="toggleSort('auxiliar','type')">
                        <span v-if="isSorted('auxiliar','type')">{{ sortState.auxiliar.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Estatus
                      <button class="sort-btn" @click="toggleSort('auxiliar','status')">
                        <span v-if="isSorted('auxiliar','status')">{{ sortState.auxiliar.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(order, index) in auxiliarPaginatedInProcessOrders" :key="index" :class="{ 'row-cancelado-glow': hasCanceladoInRow(order), 'row-insurer-pending-glow': isInsurerPendingRow(order), 'row-overdue-glow': isOverdueRow(order) }">
                    <td>
                      <span class="note-pill"
                            :style="{ '--eta': calculateGradient(order.request_time, order.expected_time, order.arrival_time) }"
                            @click="viewNoteDetails(order.type, order.note_ident)">
                        {{ order.note_number }}
                      </span>
                    </td>
                    <td>
                      {{ order.request_time.substring(8,10) }}/{{ order.request_time.substring(5,7) }}/{{ order.request_time.substring(0,4) }}
                      {{ order.request_time.substring(11,16) }}
                    </td>
                    <td>{{ order.client }}</td>
                    <td>{{ order.source.neighborhood }}, {{ order.source.city }}, {{ order.source.state }}</td>
                    <td>{{ order.aux_requested_service }}</td>
                    <td>{{ order.start_time.substring(11,16) }}</td>
                    <td>{{ order.contact_time.substring(11,16) }}</td>
                    <td>{{ order.unit_id }}</td>
                    <td>{{ order.operator_employee_ident }}</td>
                    <td>{{ order.file_number }}</td>
                    <td>{{ order.data_entry_clerk }}</td>
                    <td>{{ order.type === 'Asistencia víal' ? 'Remolque' : order.type }}</td>
                    <td>
                      <span v-if="order.status === 'Activo'" class="status status--ok">Activo</span>
                      <span v-else-if="order.status === 'Asignada'" class="status status--info">Asignada</span>
                      <span v-else-if="order.status === 'Cancelado'" class="status status--danger">Cancelado</span>
                      <span v-else-if="order.status === 'Programado'" class="status status--warn">Pendiente</span>
                      <span v-else-if="order.status === 'Completado'" class="status status--ok">Completado</span>
                      <span v-else class="status">{{ order.status }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="pagination-container">
                <button @click="prevPageAuxiliar" :disabled="auxiliarCurrentPage === 1">
                  <img src="@/assets/angulo-izquierdo.png" alt="Previous Page" />
                </button>
                <span v-for="pageNumber in auxiliarTotalInProcessPages"
                      :key="pageNumber"
                      @click="goToPageAuxiliar(pageNumber)"
                      :class="{ active: pageNumber === auxiliarCurrentPage }">
                  {{ pageNumber }}
                </span>
                <button @click="nextPageAuxiliar" :disabled="auxiliarCurrentPage >= auxiliarTotalInProcessPages">
                  <img src="@/assets/angulo-derecho.png" alt="Next Page" />
                </button>
              </div>
            </div>

            <!-- Scheduled -->
            <div class="table-container card-wrap">
              <h2>Órdenes pendientes</h2>
              <table class="table">
                <thead>
                  <tr>
                    <th>
                      ID
                      <button class="sort-btn" @click="toggleSort('auxiliarScheduled','note_number')">
                        <span v-if="isSorted('auxiliarScheduled','note_number')">{{ sortState.auxiliarScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Solicitud
                      <button class="sort-btn" @click="toggleSort('auxiliarScheduled','request_time')">
                        <span v-if="isSorted('auxiliarScheduled','request_time')">{{ sortState.auxiliarScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Cliente
                      <button class="sort-btn" @click="toggleSort('auxiliarScheduled','client')">
                        <span v-if="isSorted('auxiliarScheduled','client')">{{ sortState.auxiliarScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>Origen</th>
                    <th>Servicio</th>
                    <th>
                      Inicio
                      <button class="sort-btn" @click="toggleSort('auxiliarScheduled','start_time')">
                        <span v-if="isSorted('auxiliarScheduled','start_time')">{{ sortState.auxiliarScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Contacto
                      <button class="sort-btn" @click="toggleSort('auxiliarScheduled','contact_time')">
                        <span v-if="isSorted('auxiliarScheduled','contact_time')">{{ sortState.auxiliarScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Unidad
                      <button class="sort-btn" @click="toggleSort('auxiliarScheduled','unit_id')">
                        <span v-if="isSorted('auxiliarScheduled','unit_id')">{{ sortState.auxiliarScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Operador
                      <button class="sort-btn" @click="toggleSort('auxiliarScheduled','operator_employee_ident')">
                        <span v-if="isSorted('auxiliarScheduled','operator_employee_ident')">{{ sortState.auxiliarScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Expediente
                      <button class="sort-btn" @click="toggleSort('auxiliarScheduled','file_number')">
                        <span v-if="isSorted('auxiliarScheduled','file_number')">{{ sortState.auxiliarScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>Capturista</th>
                    <th>
                      Tipo
                      <button class="sort-btn" @click="toggleSort('auxiliarScheduled','type')">
                        <span v-if="isSorted('auxiliarScheduled','type')">{{ sortState.auxiliarScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Estatus
                      <button class="sort-btn" @click="toggleSort('auxiliarScheduled','status')">
                        <span v-if="isSorted('auxiliarScheduled','status')">{{ sortState.auxiliarScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(order, index) in auxiliarPaginatedScheduledOrders" :key="index" :class="{ 'row-cancelado-glow': hasCanceladoInRow(order), 'row-insurer-pending-glow': isInsurerPendingRow(order), 'row-overdue-glow': isOverdueRow(order) }">
                    <td>
                      <span class="note-pill"
                            :style="{ '--eta': calculateGradient(order.request_time, order.expected_time, order.arrival_time) }"
                            @click="viewNoteDetails(order.type, order.note_ident)">
                        {{ order.note_number }}
                      </span>
                    </td>
                    <td>
                      {{ order.request_time.substring(8,10) }}/{{ order.request_time.substring(5,7) }}/{{ order.request_time.substring(0,4) }}
                      {{ order.request_time.substring(11,16) }}
                    </td>
                    <td>{{ order.client }}</td>
                    <td>{{ order.source.neighborhood }}, {{ order.source.city }}, {{ order.source.state }}</td>
                    <td>{{ order.aux_requested_service }}</td>
                    <td>{{ order.start_time.substring(11,16) }}</td>
                    <td>{{ order.contact_time.substring(11,16) }}</td>
                    <td>{{ order.unit_id }}</td>
                    <td>{{ order.operator_employee_ident }}</td>
                    <td>{{ order.file_number }}</td>
                    <td>{{ order.data_entry_clerk }}</td>
                    <td>{{ order.type === 'Asistencia víal' ? 'Remolque' : order.type }}</td>
                    <td>
                      <span v-if="order.status === 'Activo'" class="status status--ok">Activo</span>
                      <span v-else-if="order.status === 'Asignada'" class="status status--info">Asignada</span>
                      <span v-else-if="order.status === 'Cancelado'" class="status status--danger">Cancelado</span>
                      <span v-else-if="order.status === 'Programado'" class="status status--warn">Pendiente</span>
                      <span v-else-if="order.status === 'Completado'" class="status status--ok">Completado</span>
                      <span v-else class="status">{{ order.status }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="pagination-container">
                <button @click="prevScheduledPageAuxiliar" :disabled="auxiliarCurrentScheduledPage === 1">
                  <img src="@/assets/angulo-izquierdo.png" alt="Previous Page" />
                </button>
                <span v-for="pageNumberScheduled in auxiliarTotalScheduledPages"
                      :key="pageNumberScheduled"
                      @click="goToScheduledPageAuxiliar(pageNumberScheduled)"
                      :class="{ active: pageNumberScheduled === auxiliarCurrentScheduledPage }">
                  {{ pageNumberScheduled }}
                </span>
                <button @click="nextScheduledPageAuxiliar" :disabled="auxiliarCurrentScheduledPage >= auxiliarTotalScheduledPages">
                  <img src="@/assets/angulo-derecho.png" alt="Next Page" />
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- ============ TAB 4: LOTE ============ -->
        <div class="tab-pane" :class="{ active: activeTab === 'tab4' }" v-show="activeTab === 'tab4'">
          <div id="ContentForLot">
            <div class="text-operations card-strip">
              <h2>Órdenes de trabajo: {{ totalLotStatusCounts }}</h2>
            </div>
            <div class="action-buttons">
              <button @click="globalfilters" v-show="canSearchAssistanceNotes" class="action-button">Maestro de búsqueda</button>
              <button @click="statusUnits" v-show="canViewStatusUnits" class="action-button">Ver estatus de unidades</button>
              <button @click="newOrder" v-show="canCreateOrder" class="action-button action-primary">Nueva orden</button>
              <button @click="rastreoUnidades" v-show="canViewMainMap" class="action-button">Rastreo unidades</button>
            </div>

            <!-- In process -->
            <div class="table-container card-wrap">
              <h2>Órdenes en proceso</h2>
              <table class="table table--route">
                <thead>
                  <tr>
                    <th>
                      ID
                      <button class="sort-btn" @click="toggleSort('lot','note_number')">
                        <span v-if="isSorted('lot','note_number')">{{ sortState.lot.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Solicitud
                      <button class="sort-btn" @click="toggleSort('lot','request_time')">
                        <span v-if="isSorted('lot','request_time')">{{ sortState.lot.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Cliente
                      <button class="sort-btn" @click="toggleSort('lot','client')">
                        <span v-if="isSorted('lot','client')">{{ sortState.lot.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>Origen</th>
                    <th>Destino</th>
                    <th>
                      Inicio
                      <button class="sort-btn" @click="toggleSort('lot','start_time')">
                        <span v-if="isSorted('lot','start_time')">{{ sortState.lot.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Contacto
                      <button class="sort-btn" @click="toggleSort('lot','contact_time')">
                        <span v-if="isSorted('lot','contact_time')">{{ sortState.lot.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Unidad
                      <button class="sort-btn" @click="toggleSort('lot','unit_id')">
                        <span v-if="isSorted('lot','unit_id')">{{ sortState.lot.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Operador
                      <button class="sort-btn" @click="toggleSort('lot','operator_employee_ident')">
                        <span v-if="isSorted('lot','operator_employee_ident')">{{ sortState.lot.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Expediente
                      <button class="sort-btn" @click="toggleSort('lot','file_number')">
                        <span v-if="isSorted('lot','file_number')">{{ sortState.lot.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>Capturista</th>
                    <th>
                      Tipo
                      <button class="sort-btn" @click="toggleSort('lot','type')">
                        <span v-if="isSorted('lot','type')">{{ sortState.lot.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Estatus
                      <button class="sort-btn" @click="toggleSort('lot','status')">
                        <span v-if="isSorted('lot','status')">{{ sortState.lot.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(order, index) in lotPaginatedInProcessOrders" :key="index" :class="{ 'row-cancelado-glow': hasCanceladoInRow(order), 'row-insurer-pending-glow': isInsurerPendingRow(order), 'row-overdue-glow': isOverdueRow(order) }">
                    <td>
                      <span class="note-pill"
                            :style="{ '--eta': calculateGradient(order.request_time, order.expected_time, order.arrival_time) }"
                            @click="viewNoteDetails(order.type, order.note_ident)">
                        {{ order.note_number }}
                      </span>
                    </td>
                    <td>
                      {{ order.request_time.substring(8,10) }}/{{ order.request_time.substring(5,7) }}/{{ order.request_time.substring(0,4) }}
                      {{ order.request_time.substring(11,16) }}
                    </td>
                    <td>{{ order.client }}</td>
                    <td>{{ order.source.neighborhood }}, {{ order.source.city }}, {{ order.source.state }}</td>
                    <td>{{ order.destination.neighborhood }}, {{ order.destination.city }}, {{ order.destination.state }}</td>
                    <td>{{ order.start_time.substring(11,16) }}</td>
                    <td>{{ order.contact_time.substring(11,16) }}</td>
                    <td>{{ order.unit_id }}</td>
                    <td>{{ order.operator_employee_ident }}</td>
                    <td>{{ order.file_number }}</td>
                    <td>{{ order.data_entry_clerk }}</td>
                    <td>{{ order.type === 'Asistencia víal' ? 'Remolque' : order.type }}</td>
                    <td>
                      <span v-if="order.status === 'Activo'" class="status status--ok">Activo</span>
                      <span v-else-if="order.status === 'Asignada'" class="status status--info">Asignada</span>
                      <span v-else-if="order.status === 'Cancelado'" class="status status--danger">Cancelado</span>
                      <span v-else-if="order.status === 'Programado'" class="status status--warn">Pendiente</span>
                      <span v-else-if="order.status === 'Completado'" class="status status--ok">Completado</span>
                      <span v-else class="status">{{ order.status }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="pagination-container">
                <button @click="prevPageLot" :disabled="lotCurrentPage === 1">
                  <img src="@/assets/angulo-izquierdo.png" alt="Previous Page" />
                </button>
                <span v-for="pageNumber in lotTotalInProcessPages"
                      :key="pageNumber"
                      @click="goToPageLot(pageNumber)"
                      :class="{ active: pageNumber === lotCurrentPage }">
                  {{ pageNumber }}
                </span>
                <button @click="nextPageLot" :disabled="lotCurrentPage >= lotTotalInProcessPages">
                  <img src="@/assets/angulo-derecho.png" alt="Next Page" />
                </button>
              </div>
            </div>

            <!-- Scheduled -->
            <div class="table-container card-wrap">
              <h2>Órdenes pendientes</h2>
              <table class="table table--route">
                <thead>
                  <tr>
                    <th>
                      ID
                      <button class="sort-btn" @click="toggleSort('lotScheduled','note_number')">
                        <span v-if="isSorted('lotScheduled','note_number')">{{ sortState.lotScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Solicitud
                      <button class="sort-btn" @click="toggleSort('lotScheduled','request_time')">
                        <span v-if="isSorted('lotScheduled','request_time')">{{ sortState.lotScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Cliente
                      <button class="sort-btn" @click="toggleSort('lotScheduled','client')">
                        <span v-if="isSorted('lotScheduled','client')">{{ sortState.lotScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>Origen</th>
                    <th>Destino</th>
                    <th>
                      Inicio
                      <button class="sort-btn" @click="toggleSort('lotScheduled','start_time')">
                        <span v-if="isSorted('lotScheduled','start_time')">{{ sortState.lotScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Contacto
                      <button class="sort-btn" @click="toggleSort('lotScheduled','contact_time')">
                        <span v-if="isSorted('lotScheduled','contact_time')">{{ sortState.lotScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Unidad
                      <button class="sort-btn" @click="toggleSort('lotScheduled','unit_id')">
                        <span v-if="isSorted('lotScheduled','unit_id')">{{ sortState.lotScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Operador
                      <button class="sort-btn" @click="toggleSort('lotScheduled','operator_employee_ident')">
                        <span v-if="isSorted('lotScheduled','operator_employee_ident')">{{ sortState.lotScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Expediente
                      <button class="sort-btn" @click="toggleSort('lotScheduled','file_number')">
                        <span v-if="isSorted('lotScheduled','file_number')">{{ sortState.lotScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>Capturista</th>
                    <th>
                      Tipo
                      <button class="sort-btn" @click="toggleSort('lotScheduled','type')">
                        <span v-if="isSorted('lotScheduled','type')">{{ sortState.lotScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Estatus
                      <button class="sort-btn" @click="toggleSort('lotScheduled','status')">
                        <span v-if="isSorted('lotScheduled','status')">{{ sortState.lotScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(order, index) in lotPaginatedScheduledOrders" :key="index" :class="{ 'row-cancelado-glow': hasCanceladoInRow(order), 'row-insurer-pending-glow': isInsurerPendingRow(order), 'row-overdue-glow': isOverdueRow(order) }">
                    <td>
                      <span class="note-pill"
                            :style="{ '--eta': calculateGradient(order.request_time, order.expected_time, order.arrival_time) }"
                            @click="viewNoteDetails(order.type, order.note_ident)">
                        {{ order.note_number }}
                      </span>
                    </td>
                    <td>
                      {{ order.request_time.substring(8,10) }}/{{ order.request_time.substring(5,7) }}/{{ order.request_time.substring(0,4) }}
                      {{ order.request_time.substring(11,16) }}
                    </td>
                    <td>{{ order.client }}</td>
                    <td>{{ order.source.neighborhood }}, {{ order.source.city }}, {{ order.source.state }}</td>
                    <td>{{ order.destination.neighborhood }}, {{ order.destination.city }}, {{ order.destination.state }}</td>
                    <td>{{ order.start_time.substring(11,16) }}</td>
                    <td>{{ order.contact_time.substring(11,16) }}</td>
                    <td>{{ order.unit_id }}</td>
                    <td>{{ order.operator_employee_ident }}</td>
                    <td>{{ order.file_number }}</td>
                    <td>{{ order.data_entry_clerk }}</td>
                    <td>{{ order.type === 'Asistencia víal' ? 'Remolque' : order.type }}</td>
                    <td>
                      <span v-if="order.status === 'Activo'" class="status status--ok">Activo</span>
                      <span v-else-if="order.status === 'Asignada'" class="status status--info">Asignada</span>
                      <span v-else-if="order.status === 'Cancelado'" class="status status--danger">Cancelado</span>
                      <span v-else-if="order.status === 'Programado'" class="status status--warn">Pendiente</span>
                      <span v-else-if="order.status === 'Completado'" class="status status--ok">Completado</span>
                      <span v-else class="status">{{ order.status }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="pagination-container">
                <button @click="prevScheduledPageLot" :disabled="lotCurrentScheduledPage === 1">
                  <img src="@/assets/angulo-izquierdo.png" alt="Previous Page" />
                </button>
                <span v-for="pageNumberScheduled in lotTotalScheduledPages"
                      :key="pageNumberScheduled"
                      @click="goToScheduledPageLot(pageNumberScheduled)"
                      :class="{ active: pageNumberScheduled === lotCurrentScheduledPage }">
                  {{ pageNumberScheduled }}
                </span>
                <button @click="nextScheduledPageLot" :disabled="lotCurrentScheduledPage >= lotTotalScheduledPages">
                  <img src="@/assets/angulo-derecho.png" alt="Next Page" />
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- ============ TAB 2: MONTACARGAS ============ -->
        <div class="tab-pane" :class="{ active: activeTab === 'tab2' }" v-show="activeTab === 'tab2'">
          <div id="ContentForForklift">
            <div class="text-operations card-strip">
              <h2>Órdenes de trabajo: {{ totalForkliftStatusCounts }}</h2>
            </div>
            <div class="action-buttons">
              <button @click="globalfilters" v-show="canSearchAssistanceNotes" class="action-button">Maestro de búsqueda</button>
              <button @click="statusUnits" v-show="canViewStatusUnits" class="action-button">Ver estatus de unidades</button>
              <button @click="newOrder" v-show="canCreateOrder" class="action-button action-primary">Nueva orden</button>
              <button @click="rastreoUnidades" v-show="canViewMainMap" class="action-button">Rastreo unidades</button>
            </div>

            <!-- In process -->
            <div class="table-container card-wrap">
              <h2>Órdenes en proceso</h2>
              <table class="table">
                <thead>
                  <tr>
                    <th>
                      ID
                      <button class="sort-btn" @click="toggleSort('forklift','note_number')">
                        <span v-if="isSorted('industrial','note_number')">{{ sortState.forklift.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Solicitud
                      <button class="sort-btn" @click="toggleSort('forklift','request_time')">
                        <span v-if="isSorted('industrial','request_time')">{{ sortState.forklift.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Cliente
                      <button class="sort-btn" @click="toggleSort('forklift','client')">
                        <span v-if="isSorted('industrial','client')">{{ sortState.forklift.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>Origen</th>
                    <th>
                      Inicio
                      <button class="sort-btn" @click="toggleSort('forklift','start_time')">
                        <span v-if="isSorted('industrial','start_time')">{{ sortState.forklift.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Contacto
                      <button class="sort-btn" @click="toggleSort('forklift','contact_time')">
                        <span v-if="isSorted('industrial','contact_time')">{{ sortState.forklift.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Unidad
                      <button class="sort-btn" @click="toggleSort('forklift','unit_id')">
                        <span v-if="isSorted('industrial','unit_id')">{{ sortState.forklift.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Operador
                      <button class="sort-btn" @click="toggleSort('forklift','operator_employee_ident')">
                        <span v-if="isSorted('industrial','operator_employee_ident')">{{ sortState.forklift.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Expediente
                      <button class="sort-btn" @click="toggleSort('forklift','file_number')">
                        <span v-if="isSorted('industrial','file_number')">{{ sortState.forklift.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>Capturista</th>
                    <th>
                      Estatus
                      <button class="sort-btn" @click="toggleSort('forklift','status')">
                        <span v-if="isSorted('industrial','status')">{{ sortState.forklift.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(order, index) in forkliftPaginatedInProcessOrders" :key="index" :class="{ 'row-cancelado-glow': hasCanceladoInRow(order), 'row-insurer-pending-glow': isInsurerPendingRow(order), 'row-overdue-glow': isOverdueRow(order) }">
                    <td>
                      <span class="note-pill"
                            :style="{ '--eta': calculateGradient(order.request_time, order.expected_time, order.arrival_time) }"
                            @click="viewForkliftNoteDetails(order.note_ident)">
                        {{ order.note_number }}
                      </span>
                    </td>
                    <td>
                      {{ order.request_time.substring(8,10) }}/{{ order.request_time.substring(5,7) }}/{{ order.request_time.substring(0,4) }}
                      {{ order.request_time.substring(11,16) }}
                    </td>
                    <td>{{ order.client }}</td>
                    <td>{{ order.source.neighborhood }}, {{ order.source.city }}, {{ order.source.state }}</td>
                    <td>{{ order.start_time.substring(11,16) }}</td>
                    <td>{{ order.contact_time.substring(11,16) }}</td>
                    <td>{{ order.unit_id }}</td>
                    <td>{{ order.operator_employee_ident }}</td>
                    <td>{{ order.file_number }}</td>
                    <td>{{ order.data_entry_clerk }}</td>
                    <td>
                      <span v-if="order.status === 'Activo'" class="status status--ok">Activo</span>
                      <span v-else-if="order.status === 'Asignada'" class="status status--info">Asignada</span>
                      <span v-else-if="order.status === 'Cancelado'" class="status status--danger">Cancelado</span>
                      <span v-else-if="order.status === 'Programado'" class="status status--warn">Pendiente</span>
                      <span v-else-if="order.status === 'Completado'" class="status status--ok">Completado</span>
                      <span v-else class="status">{{ order.status }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="pagination-container">
                <button @click="prevPageForklift" :disabled="forkliftCurrentPage === 1">
                  <img src="@/assets/angulo-izquierdo.png" alt="Previous Page" />
                </button>
                <span v-for="pageNumber in forkliftTotalInProcessPages"
                      :key="pageNumber"
                      @click="goToPageForklift(pageNumber)"
                      :class="{ active: pageNumber === forkliftCurrentPage }">
                  {{ pageNumber }}
                </span>
                <button @click="nextPageForklift" :disabled="forkliftCurrentPage >= forkliftTotalInProcessPages">
                  <img src="@/assets/angulo-derecho.png" alt="Next Page" />
                </button>
              </div>
            </div>

            <!-- Scheduled -->
            <div class="table-container card-wrap">
              <h2>Órdenes pendientes</h2>
              <table class="table">
                <thead>
                  <tr>
                    <th>
                      ID
                      <button class="sort-btn" @click="toggleSort('forkliftScheduled','note_number')">
                        <span v-if="isSorted('forkliftScheduled','note_number')">{{ sortState.forkliftScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Solicitud
                      <button class="sort-btn" @click="toggleSort('forkliftScheduled','request_time')">
                        <span v-if="isSorted('forkliftScheduled','request_time')">{{ sortState.forkliftScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Cliente
                      <button class="sort-btn" @click="toggleSort('forkliftScheduled','client')">
                        <span v-if="isSorted('forkliftScheduled','client')">{{ sortState.forkliftScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>Origen</th>
                    <th>
                      Inicio
                      <button class="sort-btn" @click="toggleSort('forkliftScheduled','start_time')">
                        <span v-if="isSorted('forkliftScheduled','start_time')">{{ sortState.forkliftScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Contacto
                      <button class="sort-btn" @click="toggleSort('forkliftScheduled','contact_time')">
                        <span v-if="isSorted('forkliftScheduled','contact_time')">{{ sortState.forkliftScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Unidad
                      <button class="sort-btn" @click="toggleSort('forkliftScheduled','unit_id')">
                        <span v-if="isSorted('forkliftScheduled','unit_id')">{{ sortState.forkliftScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Operador
                      <button class="sort-btn" @click="toggleSort('forkliftScheduled','operator_employee_ident')">
                        <span v-if="isSorted('forkliftScheduled','operator_employee_ident')">{{ sortState.forkliftScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Expediente
                      <button class="sort-btn" @click="toggleSort('forkliftScheduled','file_number')">
                        <span v-if="isSorted('forkliftScheduled','file_number')">{{ sortState.forkliftScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>Capturista</th>
                    <th>
                      Estatus
                      <button class="sort-btn" @click="toggleSort('forkliftScheduled','status')">
                        <span v-if="isSorted('forkliftScheduled','status')">{{ sortState.forkliftScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(order, index) in forkliftPaginatedScheduledOrders" :key="index" :class="{ 'row-cancelado-glow': hasCanceladoInRow(order), 'row-insurer-pending-glow': isInsurerPendingRow(order), 'row-overdue-glow': isOverdueRow(order) }">
                    <td>
                      <span class="note-pill"
                            :style="{ '--eta': calculateGradient(order.request_time, order.expected_time, order.arrival_time) }"
                            @click="viewForkliftNoteDetails(order.note_ident)">
                        {{ order.note_number }}
                      </span>
                    </td>
                    <td>
                      {{ order.request_time.substring(8,10) }}/{{ order.request_time.substring(5,7) }}/{{ order.request_time.substring(0,4) }}
                      {{ order.request_time.substring(11,16) }}
                    </td>
                    <td>{{ order.client }}</td>
                    <td>{{ order.source.neighborhood }}, {{ order.source.city }}, {{ order.source.state }}</td>
                    <td>{{ order.start_time.substring(11,16) }}</td>
                    <td>{{ order.contact_time.substring(11,16) }}</td>
                    <td>{{ order.unit_id }}</td>
                    <td>{{ order.operator_employee_ident }}</td>
                    <td>{{ order.file_number }}</td>
                    <td>{{ order.data_entry_clerk }}</td>
                    <td>
                      <span v-if="order.status === 'Activo'" class="status status--ok">Activo</span>
                      <span v-else-if="order.status === 'Asignada'" class="status status--info">Asignada</span>
                      <span v-else-if="order.status === 'Cancelado'" class="status status--danger">Cancelado</span>
                      <span v-else-if="order.status === 'Programado'" class="status status--warn">Pendiente</span>
                      <span v-else-if="order.status === 'Completado'" class="status status--ok">Completado</span>
                      <span v-else class="status">{{ order.status }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="pagination-container">
                <button @click="prevScheduledPageForklift" :disabled="forkliftCurrentScheduledPage === 1">
                  <img src="@/assets/angulo-izquierdo.png" alt="Previous Page" />
                </button>
                <span v-for="pageNumberScheduled in forkliftTotalScheduledPages"
                      :key="pageNumberScheduled"
                      @click="goToScheduledPageForklift(pageNumberScheduled)"
                      :class="{ active: pageNumberScheduled === forkliftCurrentScheduledPage }">
                  {{ pageNumberScheduled }}
                </span>
                <button @click="nextScheduledPageForklift" :disabled="forkliftCurrentScheduledPage >= forkliftTotalScheduledPages">
                  <img src="@/assets/angulo-derecho.png" alt="Next Page" />
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- ============ TAB 8: INDUSTRIAL ============ -->
        <div class="tab-pane" :class="{ active: activeTab === 'tab8' }" v-show="activeTab === 'tab8'">
          <div id="ContentForIndustrial">
            <div class="text-operations card-strip">
              <h2>Órdenes de trabajo: {{ totalIndustrialStatusCounts }}</h2>
            </div>
            <div class="action-buttons">
              <button @click="globalfilters" v-show="canSearchAssistanceNotes" class="action-button">Maestro de búsqueda</button>
              <button @click="statusUnits" v-show="canViewStatusUnits" class="action-button">Ver estatus de unidades</button>
              <button @click="newOrder" v-show="canCreateOrder" class="action-button action-primary">Nueva orden</button>
              <button @click="rastreoUnidades" v-show="canViewMainMap" class="action-button">Rastreo unidades</button>
            </div>

            <!-- In process -->
            <div class="table-container card-wrap">
              <h2>Órdenes en proceso</h2>
              <table class="table">
                <thead>
                  <tr>
                    <th>
                      ID
                      <button class="sort-btn" @click="toggleSort('industrial','note_number')">
                        <span v-if="isSorted('industrial','note_number')">{{ sortState.industrial.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Solicitud
                      <button class="sort-btn" @click="toggleSort('industrial','request_time')">
                        <span v-if="isSorted('industrial','request_time')">{{ sortState.industrial.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Cliente
                      <button class="sort-btn" @click="toggleSort('industrial','client')">
                        <span v-if="isSorted('industrial','client')">{{ sortState.industrial.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>Origen</th>
                    <th>
                      Inicio
                      <button class="sort-btn" @click="toggleSort('industrial','start_time')">
                        <span v-if="isSorted('industrial','start_time')">{{ sortState.industrial.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Contacto
                      <button class="sort-btn" @click="toggleSort('industrial','contact_time')">
                        <span v-if="isSorted('industrial','contact_time')">{{ sortState.industrial.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Unidad
                      <button class="sort-btn" @click="toggleSort('industrial','unit_id')">
                        <span v-if="isSorted('industrial','unit_id')">{{ sortState.industrial.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Operador
                      <button class="sort-btn" @click="toggleSort('industrial','operator_employee_ident')">
                        <span v-if="isSorted('industrial','operator_employee_ident')">{{ sortState.industrial.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Expediente
                      <button class="sort-btn" @click="toggleSort('industrial','file_number')">
                        <span v-if="isSorted('industrial','file_number')">{{ sortState.industrial.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>Capturista</th>
                    <th>
                      Estatus
                      <button class="sort-btn" @click="toggleSort('industrial','status')">
                        <span v-if="isSorted('industrial','status')">{{ sortState.industrial.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(order, index) in industrialPaginatedInProcessOrders" :key="index" :class="{ 'row-cancelado-glow': hasCanceladoInRow(order), 'row-insurer-pending-glow': isInsurerPendingRow(order), 'row-overdue-glow': isOverdueRow(order) }">
                    <td>
                      <span class="note-pill"
                            :style="{ '--eta': calculateGradient(order.request_time, order.expected_time, order.arrival_time) }"
                            @click="viewIndustrialNoteDetails(order.note_ident)">
                        {{ order.note_number }}
                      </span>
                    </td>
                    <td>
                      {{ order.request_time.substring(8,10) }}/{{ order.request_time.substring(5,7) }}/{{ order.request_time.substring(0,4) }}
                      {{ order.request_time.substring(11,16) }}
                    </td>
                    <td>{{ order.client }}</td>
                    <td>{{ order.source.neighborhood }}, {{ order.source.city }}, {{ order.source.state }}</td>
                    <td>{{ order.start_time.substring(11,16) }}</td>
                    <td>{{ order.contact_time.substring(11,16) }}</td>
                    <td>{{ order.unit_id }}</td>
                    <td>{{ order.operator_employee_ident }}</td>
                    <td>{{ order.file_number }}</td>
                    <td>{{ order.data_entry_clerk }}</td>
                    <td>
                      <span v-if="order.status === 'Activo'" class="status status--ok">Activo</span>
                      <span v-else-if="order.status === 'Asignada'" class="status status--info">Asignada</span>
                      <span v-else-if="order.status === 'Cancelado'" class="status status--danger">Cancelado</span>
                      <span v-else-if="order.status === 'Programado'" class="status status--warn">Pendiente</span>
                      <span v-else-if="order.status === 'Completado'" class="status status--ok">Completado</span>
                      <span v-else class="status">{{ order.status }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="pagination-container">
                <button @click="prevPageIndustrial" :disabled="industrialCurrentPage === 1">
                  <img src="@/assets/angulo-izquierdo.png" alt="Previous Page" />
                </button>
                <span v-for="pageNumber in industrialTotalInProcessPages"
                      :key="pageNumber"
                      @click="goToPageIndustrial(pageNumber)"
                      :class="{ active: pageNumber === industrialCurrentPage }">
                  {{ pageNumber }}
                </span>
                <button @click="nextPageIndustrial" :disabled="industrialCurrentPage >= industrialTotalInProcessPages">
                  <img src="@/assets/angulo-derecho.png" alt="Next Page" />
                </button>
              </div>
            </div>

            <!-- Scheduled -->
            <div class="table-container card-wrap">
              <h2>Órdenes pendientes</h2>
              <table class="table">
                <thead>
                  <tr>
                    <th>
                      ID
                      <button class="sort-btn" @click="toggleSort('industrialScheduled','note_number')">
                        <span v-if="isSorted('industrialScheduled','note_number')">{{ sortState.industrialScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Solicitud
                      <button class="sort-btn" @click="toggleSort('industrialScheduled','request_time')">
                        <span v-if="isSorted('industrialScheduled','request_time')">{{ sortState.industrialScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Cliente
                      <button class="sort-btn" @click="toggleSort('industrialScheduled','client')">
                        <span v-if="isSorted('industrialScheduled','client')">{{ sortState.industrialScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>Origen</th>
                    <th>
                      Inicio
                      <button class="sort-btn" @click="toggleSort('industrialScheduled','start_time')">
                        <span v-if="isSorted('industrialScheduled','start_time')">{{ sortState.industrialScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Contacto
                      <button class="sort-btn" @click="toggleSort('industrialScheduled','contact_time')">
                        <span v-if="isSorted('industrialScheduled','contact_time')">{{ sortState.industrialScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Unidad
                      <button class="sort-btn" @click="toggleSort('industrialScheduled','unit_id')">
                        <span v-if="isSorted('industrialScheduled','unit_id')">{{ sortState.industrialScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Operador
                      <button class="sort-btn" @click="toggleSort('industrialScheduled','operator_employee_ident')">
                        <span v-if="isSorted('industrialScheduled','operator_employee_ident')">{{ sortState.industrialScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Expediente
                      <button class="sort-btn" @click="toggleSort('industrialScheduled','file_number')">
                        <span v-if="isSorted('industrialScheduled','file_number')">{{ sortState.industrialScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>Capturista</th>
                    <th>
                      Estatus
                      <button class="sort-btn" @click="toggleSort('industrialScheduled','status')">
                        <span v-if="isSorted('industrialScheduled','status')">{{ sortState.industrialScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(order, index) in industrialPaginatedScheduledOrders" :key="index" :class="{ 'row-cancelado-glow': hasCanceladoInRow(order), 'row-insurer-pending-glow': isInsurerPendingRow(order), 'row-overdue-glow': isOverdueRow(order) }">
                    <td>
                      <span class="note-pill"
                            :style="{ '--eta': calculateGradient(order.request_time, order.expected_time, order.arrival_time) }"
                            @click="viewIndustrialNoteDetails(order.note_ident)">
                        {{ order.note_number }}
                      </span>
                    </td>
                    <td>
                      {{ order.request_time.substring(8,10) }}/{{ order.request_time.substring(5,7) }}/{{ order.request_time.substring(0,4) }}
                      {{ order.request_time.substring(11,16) }}
                    </td>
                    <td>{{ order.client }}</td>
                    <td>{{ order.source.neighborhood }}, {{ order.source.city }}, {{ order.source.state }}</td>
                    <td>{{ order.start_time.substring(11,16) }}</td>
                    <td>{{ order.contact_time.substring(11,16) }}</td>
                    <td>{{ order.unit_id }}</td>
                    <td>{{ order.operator_employee_ident }}</td>
                    <td>{{ order.file_number }}</td>
                    <td>{{ order.data_entry_clerk }}</td>
                    <td>
                      <span v-if="order.status === 'Activo'" class="status status--ok">Activo</span>
                      <span v-else-if="order.status === 'Asignada'" class="status status--info">Asignada</span>
                      <span v-else-if="order.status === 'Cancelado'" class="status status--danger">Cancelado</span>
                      <span v-else-if="order.status === 'Programado'" class="status status--warn">Pendiente</span>
                      <span v-else-if="order.status === 'Completado'" class="status status--ok">Completado</span>
                      <span v-else class="status">{{ order.status }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="pagination-container">
                <button @click="prevScheduledPageIndustrial" :disabled="industrialCurrentScheduledPage === 1">
                  <img src="@/assets/angulo-izquierdo.png" alt="Previous Page" />
                </button>
                <span v-for="pageNumberScheduled in industrialTotalScheduledPages"
                      :key="pageNumberScheduled"
                      @click="goToScheduledPageIndustrial(pageNumberScheduled)"
                      :class="{ active: pageNumberScheduled === industrialCurrentScheduledPage }">
                  {{ pageNumberScheduled }}
                </span>
                <button @click="nextScheduledPageIndustrial" :disabled="industrialCurrentScheduledPage >= industrialTotalScheduledPages">
                  <img src="@/assets/angulo-derecho.png" alt="Next Page" />
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- ============ TAB 5: ÓRDENES EN PROGRESO ============ -->
        <div class="tab-pane" :class="{ active: activeTab === 'tab5' }" v-show="activeTab === 'tab5'">
          <div id="ContentForInProgress">
            <div class="text-operations card-strip">
              <h2>Órdenes de trabajo: {{ totalAllStatusCounts }}</h2>
            </div>

            <div class="action-buttons">
              <button @click="globalfilters" v-show="canSearchAssistanceNotes" class="action-button">Maestro de búsqueda</button>
              <button @click="statusUnits" v-show="canViewStatusUnits" class="action-button">Ver estatus de unidades</button>
              <button @click="newOrder" v-show="canCreateOrder" class="action-button action-primary">Nueva orden</button>
              <button @click="rastreoUnidades" v-show="canViewMainMap" class="action-button">Rastreo unidades</button>
            </div>

            <!-- In process -->
            <div class="table-container card-wrap">
              <h2>Órdenes en proceso</h2>
              <table class="table table--workorders">
                <thead>
                  <tr>
                    <th>
                      ID
                      <button class="sort-btn" @click="toggleSort('allInProcess','note_number')">
                        <span v-if="isSorted('allInProcess','note_number')">{{ sortState.allInProcess.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Solicitud
                      <button class="sort-btn" @click="toggleSort('allInProcess','request_time')">
                        <span v-if="isSorted('allInProcess','request_time')">{{ sortState.allInProcess.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Cliente
                      <button class="sort-btn" @click="toggleSort('allInProcess','client')">
                        <span v-if="isSorted('allInProcess','client')">{{ sortState.allInProcess.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Inicio
                      <button class="sort-btn" @click="toggleSort('allInProcess','start_time')">
                        <span v-if="isSorted('allInProcess','start_time')">{{ sortState.allInProcess.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Contacto
                      <button class="sort-btn" @click="toggleSort('allInProcess','contact_time')">
                        <span v-if="isSorted('allInProcess','contact_time')">{{ sortState.allInProcess.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Unidad
                      <button class="sort-btn" @click="toggleSort('allInProcess','unit_id')">
                        <span v-if="isSorted('allInProcess','unit_id')">{{ sortState.allInProcess.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Operador
                      <button class="sort-btn" @click="toggleSort('allInProcess','operator_employee_ident')">
                        <span v-if="isSorted('allInProcess','operator_employee_ident')">{{ sortState.allInProcess.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Expediente
                      <button class="sort-btn" @click="toggleSort('allInProcess','file_number')">
                        <span v-if="isSorted('allInProcess','file_number')">{{ sortState.allInProcess.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Capturista
                    </th>
                    <th>
                      Sucursal
                      <button class="sort-btn" @click="toggleSort('allInProcess','sucursal')">
                        <span v-if="isSorted('allInProcess','sucursal')">{{ sortState.allInProcess.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(order, index) in allPaginatedInProcessOrders" :key="index" :class="{ 'row-cancelado-glow': hasCanceladoInRow(order), 'row-insurer-pending-glow': isInsurerPendingRow(order), 'row-overdue-glow': isOverdueRow(order) }">
                    <td>
                      <span class="note-pill"
                            :style="{ '--eta': calculateGradient(order.request_time, order.expected_time, order.arrival_time) }"
                            @click="viewForkliftNoteDetails(order.note_ident)">
                        {{ order.note_number }}
                      </span>
                    </td>
                    <td>
                      {{ order.request_time.substring(8,10) }}/{{ order.request_time.substring(5,7) }}/{{ order.request_time.substring(0,4) }}
                      {{ order.request_time.substring(11,16) }}
                    </td>
                    <td>{{ order.client }}</td>
                    <td>{{ order.start_time.substring(11,16) }}</td>
                    <td>{{ order.contact_time.substring(11,16) }}</td>
                    <td>{{ order.unit_id }}</td>
                    <td>{{ order.operator_employee_ident }}</td>
                    <td>{{ order.file_number }}</td>
                    <td>{{ order.data_entry_clerk }}</td>
                    <td>{{ order.sucursal }}</td>
                  </tr>
                </tbody>
              </table>

              <div class="pagination-container">
                <button @click="prevPageInProgress" :disabled="InProgressCurrentPage === 1">
                  <img src="@/assets/angulo-izquierdo.png" alt="Previous Page" />
                </button>
                <span v-for="pageNumber in allTotalInProcessPages"
                      :key="pageNumber"
                      @click="goToPageForklift(pageNumber)"
                      :class="{ active: pageNumber === InProgressCurrentPage }">
                  {{ pageNumber }}
                </span>
                <button @click="nextPageInProgress" :disabled="InProgressCurrentPage >= allTotalInProcessPages">
                  <img src="@/assets/angulo-derecho.png" alt="Next Page" />
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- ============ TAB 6: ÓRDENES PROGRAMADAS ============ -->
        <div class="tab-pane" :class="{ active: activeTab === 'tab6' }" v-show="activeTab === 'tab6'">
          <div id="ContentForInProgress">
            <div class="text-operations card-strip">
              <h2>Órdenes de trabajo: {{ totalScheduledStatusCounts }}</h2>
            </div>

            <div class="action-buttons">
              <button @click="globalfilters" v-show="canSearchAssistanceNotes" class="action-button">Maestro de búsqueda</button>
              <button @click="statusUnits" v-show="canViewStatusUnits" class="action-button">Ver estatus de unidades</button>
              <button @click="newOrder" v-show="canCreateOrder" class="action-button action-primary">Nueva orden</button>
              <button @click="rastreoUnidades" v-show="canViewMainMap" class="action-button">Rastreo unidades</button>
            </div>

            <!-- In process -->
            <div class="table-container card-wrap">
              <h2>Órdenes programadas</h2>
              <table class="table table--workorders">
                <thead>
                  <tr>
                    <th>
                      # Programación
                      <button class="sort-btn" @click="toggleSort('allScheduled','scheduled_number')">
                        <span v-if="isSorted('allScheduled','scheduled_number')">{{ sortState.allScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Programado para
                      <button class="sort-btn" @click="toggleSort('allScheduled','scheduled_for')">
                        <span v-if="isSorted('allScheduled','scheduled_for')">{{ sortState.allScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Cliente
                      <button class="sort-btn" @click="toggleSort('allScheduled','client')">
                        <span v-if="isSorted('allScheduled','client')">{{ sortState.allScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Inicio
                      <button class="sort-btn" @click="toggleSort('allScheduled','start_time')">
                        <span v-if="isSorted('allScheduled','start_time')">{{ sortState.allScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Contacto
                      <button class="sort-btn" @click="toggleSort('allScheduled','contact_time')">
                        <span v-if="isSorted('allScheduled','contact_time')">{{ sortState.allScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Unidad
                      <button class="sort-btn" @click="toggleSort('allScheduled','unit_id')">
                        <span v-if="isSorted('allScheduled','unit_id')">{{ sortState.allScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Operador
                      <button class="sort-btn" @click="toggleSort('allScheduled','operator_employee_ident')">
                        <span v-if="isSorted('allScheduled','operator_employee_ident')">{{ sortState.allScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Expediente
                      <button class="sort-btn" @click="toggleSort('allScheduled','file_number')">
                        <span v-if="isSorted('allScheduled','file_number')">{{ sortState.allScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>Capturista</th>
                    <th>
                      Sucursal
                      <button class="sort-btn" @click="toggleSort('allScheduled','sucursal')">
                        <span v-if="isSorted('allScheduled','sucursal')">{{ sortState.allScheduled.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(order, index) in allPaginatedScheduledOrders" :key="index" :class="{ 'row-cancelado-glow': hasCanceladoInRow(order), 'row-insurer-pending-glow': isInsurerPendingRow(order), 'row-overdue-glow': isOverdueRow(order) }">
                    <td>
                      <span class="note-pill"
                            :style="{ '--eta': calculateGradient(order.request_time, order.expected_time, order.arrival_time) }"
                            @click="viewScheduledNoteDetails(order.type, order.scheduled_number)">
                        {{ order.scheduled_number }}
                      </span>
                    </td>
                    <td>
                      {{ order.scheduled_for.substring(8,10) }}/{{ order.scheduled_for.substring(5,7) }}/{{ order.scheduled_for.substring(0,4) }}
                      {{ order.scheduled_for.substring(11,16) }}
                    </td>
                    <td>{{ order.client }}</td>
                    <td>{{ order.start_time.substring(11,16) }}</td>
                    <td>{{ order.contact_time.substring(11,16) }}</td>
                    <td>{{ order.unit_id }}</td>
                    <td>{{ order.operator_employee_ident }}</td>
                    <td>{{ order.file_number }}</td>
                    <td>{{ order.data_entry_clerk }}</td>
                    <td>{{ order.sucursal }}</td>
                  </tr>
                </tbody>
              </table>
              <div class="pagination-container">
                <button @click="prevPageSceduled" :disabled="scheduledCurrentPage === 1">
                  <img src="@/assets/angulo-izquierdo.png" alt="Previous Page" />
                </button>
                <span v-for="pageNumber in allTotalScheduledPages"
                      :key="pageNumber"
                      @click="goToPageScheduled(pageNumber)"
                      :class="{ active: pageNumber === scheduledCurrentPage }">
                  {{ pageNumber }}
                </span>
                <button @click="nextPageInProgress" :disabled="scheduledCurrentPage >= allTotalScheduledPages">
                  <img src="@/assets/angulo-derecho.png" alt="Next Page" />
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- ============ TAB 7: ÓRDENES EN LOTE ============ -->
        <div class="tab-pane" :class="{ active: activeTab === 'tab7' }" v-show="activeTab === 'tab7'">
          <div id="ContentForInLot">
            <div class="text-operations card-strip">
              <h2>Órdenes de trabajo: {{ totalInLotStatusCounts }}</h2>
            </div>

            <div class="action-buttons">
              <button @click="globalfilters" v-show="canSearchAssistanceNotes" class="action-button">Maestro de búsqueda</button>
              <button @click="statusUnits" v-show="canViewStatusUnits" class="action-button">Ver estatus de unidades</button>
              <button @click="newOrder" v-show="canCreateOrder" class="action-button action-primary">Nueva orden</button>
              <button @click="rastreoUnidades" v-show="canViewMainMap" class="action-button">Rastreo unidades</button>
            </div>

            <!-- In process -->
            <div class="table-container card-wrap">
              <h2>Órdenes en lote</h2>
              <table class="table table--workorders">
                <thead>
                  <tr>
                    <th>
                      ID
                      <button class="sort-btn" @click="toggleSort('allInLot','note_number')">
                        <span v-if="isSorted('allInLot','note_number')">{{ sortState.allInLot.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th style="width: 80px; white-space: nowrap; text-align: center;">
                      Solicitud
                      <button class="sort-btn" @click="toggleSort('allInLot','request_time')">
                        <span v-if="isSorted('allInLot','request_time')">{{ sortState.allInLot.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Cliente
                      <button class="sort-btn" @click="toggleSort('allInLot','client')">
                        <span v-if="isSorted('allInLot','client')">{{ sortState.allInLot.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Inicio
                      <button class="sort-btn" @click="toggleSort('allInLot','start_time')">
                        <span v-if="isSorted('allInLot','start_time')">{{ sortState.allInLot.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Contacto
                      <button class="sort-btn" @click="toggleSort('allInLot','contact_time')">
                        <span v-if="isSorted('allInLot','contact_time')">{{ sortState.allInLot.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Unidad
                      <button class="sort-btn" @click="toggleSort('allInLot','unit_id')">
                        <span v-if="isSorted('allInLot','unit_id')">{{ sortState.allInLot.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Operador
                      <button class="sort-btn" @click="toggleSort('allInLot','operator_employee_ident')">
                        <span v-if="isSorted('allInLot','operator_employee_ident')">{{ sortState.allInLot.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Expediente
                      <button class="sort-btn" @click="toggleSort('allInLot','file_number')">
                        <span v-if="isSorted('allInLot','file_number')">{{ sortState.allInLot.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th>
                      Capturista
                    </th>
                    <th>
                      Sucursal
                      <button class="sort-btn" @click="toggleSort('allInLot','sucursal')">
                        <span v-if="isSorted('allInLot','sucursal')">{{ sortState.allInLot.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th style="width: 110px; white-space: nowrap; text-align: center;">
                      Autoridad
                      <button class="sort-btn" @click="toggleSort('allInLot','lot_authority')">
                        <span v-if="isSorted('allInLot','lot_authority')">{{ sortState.allInLot.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                    <th style="width: 110px; white-space: nowrap; text-align: center;">
                      Carretera
                      <button class="sort-btn" @click="toggleSort('allInLot','lot')">
                        <span v-if="isSorted('allInLot','lot')">{{ sortState.allInLot.dir==='asc'?'▲':'▼' }}</span><span v-else>↕</span>
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(order, index) in allPaginatedInLotOrders" :key="index" :class="{ 'row-cancelado-glow': hasCanceladoInRow(order), 'row-insurer-pending-glow': isInsurerPendingRow(order), 'row-overdue-glow': isOverdueRow(order) }">
                    <td>
                      <span class="note-pill"
                            :style="{ '--eta': calculateGradient(order.request_time, order.expected_time, order.arrival_time) }"
                            @click="viewNoteDetails(order.type, order.note_ident)">
                        {{ order.note_number }}
                      </span>
                    </td>
                    <td>
                      {{ order.request_time.substring(8,10) }}/{{ order.request_time.substring(5,7) }}/{{ order.request_time.substring(0,4) }}
                      {{ order.request_time.substring(11,16) }}
                    </td>
                    <td>{{ order.client }}</td>
                    <td>{{ order.start_time.substring(11,16) }}</td>
                    <td>{{ order.contact_time.substring(11,16) }}</td>
                    <td>{{ order.unit_id }}</td>
                    <td>{{ order.operator_employee_ident }}</td>
                    <td>{{ order.file_number }}</td>
                    <td>{{ order.data_entry_clerk }}</td>
                    <td>{{ order.sucursal }}</td>
                    <td>{{ order.lot_authority }}</td>
                    <td>{{ order.lot }}</td>
                  </tr>
                </tbody>
              </table>

              <div class="pagination-container">
                <button @click="prevPageInLot" :disabled="InLotCurrentPage === 1">
                  <img src="@/assets/angulo-izquierdo.png" alt="Previous Page" />
                </button>
                <span v-for="pageNumber in allTotalInLotPages"
                      :key="pageNumber"
                      @click="goToPageInLot(pageNumber)"
                      :class="{ active: pageNumber === InLotCurrentPage }">
                  {{ pageNumber }}
                </span>
                <button @click="nextPageInLot" :disabled="InLotCurrentPage >= allTotalInLotPages">
                  <img src="@/assets/angulo-derecho.png" alt="Next Page" />
                </button>
              </div>
            </div>
          </div>
        </div>

      </div><!-- /tab-content -->
    </div><!-- /container -->
    <div
      v-if="insurerModalOpen"
      class="modal-overlay"
      @click.self="closeInsurerModalAndRelease"
    >
      <div class="modal-card insurer-modal-card insurer-modal-card--wide">
        <h3>Detalle de servicio aseguradora</h3>
        <div v-if="activeInsurerService" class="insurer-modal-layout">
          <div class="insurer-modal-main">
            <p><strong>Expediente:</strong> {{ activeInsurerService.expediente }}</p>
            <p><strong>Servicio:</strong> {{ activeInsurerService.insurer_service_id }}</p>
            <div class="insurer-service-type">
              <span class="insurer-service-type__label">Tipo de servicio</span>
              <strong class="insurer-service-type__value">
                {{ activeInsurerService.insurer_payload?.tipoServicio || 'N/A' }}
              </strong>
            </div>
            <p
              v-if="insurerCountdown"
              class="insurer-countdown"
              :class="{
                'insurer-countdown--warning': insurerCountdown.seconds <= 300 && !insurerCountdown.expired,
                'insurer-countdown--expired': insurerCountdown.expired
              }"
            >
              <strong>Tiempo para aceptar:</strong> {{ insurerCountdown.label }}
            </p>
            <p>
              <strong>Origen:</strong>
              {{ activeInsurerService.insurer_payload?.direccionOrigen || 'N/A' }}
            </p>
            <p>
              <strong>Destino:</strong>
              {{ activeInsurerService.insurer_payload?.direccionDestino || 'N/A' }}
            </p>
            <p>
              <strong>Problema:</strong>
              {{ activeInsurerService.insurer_payload?.problema || 'N/A' }}
            </p>
            <p>
              <strong>Marca:</strong>
              {{ activeInsurerService.note_vehicle_brand || 'N/A' }}
            </p>
            <p>
              <strong>Submarca:</strong>
              {{ activeInsurerService.note_vehicle_sub_brand || 'N/A' }}
            </p>

            <div class="insurer-assign-grid">
              <div class="insurer-field">
                <label>Unidad</label>
                <input
                  v-model="insurerAssignForm.unit"
                  type="text"
                  placeholder="Ej. MTY-001"
                  :disabled="insurerTimeoutLocked || insurerTimeoutHandling || insurerActionLoading"
                  @blur="resolveInsurerAssignationInputs"
                />
                <small v-if="insurerResolved.unitName" class="insurer-resolved ok">
                  {{ insurerResolved.unitName }}
                </small>
                <small v-else-if="insurerResolved.unitError" class="insurer-resolved err">
                  {{ insurerResolved.unitError }}
                </small>
              </div>
              <div class="insurer-field">
                <label>Operador (nómina)</label>
                <input
                  v-model="insurerAssignForm.operator"
                  type="text"
                  placeholder="Ej. OP001"
                  :disabled="insurerTimeoutLocked || insurerTimeoutHandling || insurerActionLoading"
                  @blur="resolveInsurerAssignationInputs"
                />
                <small v-if="insurerResolved.operatorName" class="insurer-resolved ok">
                  {{ insurerResolved.operatorName }}
                </small>
                <small v-else-if="insurerResolved.operatorError" class="insurer-resolved err">
                  {{ insurerResolved.operatorError }}
                </small>
              </div>
              <div class="insurer-field">
                <label>Minutos de arribo</label>
                <input
                  v-model="insurerAssignForm.minutosArribo"
                  type="number"
                  min="0"
                  placeholder="Ej. 30"
                  :disabled="insurerTimeoutLocked || insurerTimeoutHandling || insurerActionLoading"
                />
              </div>
              <div class="insurer-field insurer-field--full">
                <label>Motivo de rechazo (si aplica)</label>
                <select
                  v-model="insurerAssignForm.rejectReason"
                  :disabled="insurerTimeoutLocked || insurerTimeoutHandling || insurerActionLoading"
                >
                  <option value="arrival_time_exceeded">Tiempo de arribo mayor al permitido</option>
                  <option value="no_units_available">Proveedor sin grúas disponibles</option>
                  <option value="out_of_coverage_area">No cubrimos la zona</option>
                  <option value="bad_typification">Error de cabina / mala tipificación</option>
                  <option value="provider_cancelled">Proveedor cancela</option>
                </select>
              </div>
            </div>

            <div class="insurer-modal-actions">
              <button class="action-button" :disabled="insurerTimeoutHandling" @click="closeInsurerModalAndRelease">Cerrar</button>
              <button
                class="action-button"
                :disabled="insurerActionLoading || insurerTimeoutLocked || insurerTimeoutHandling || !insurerAssignForm.unit || !insurerAssignForm.operator"
                @click="acceptInsurerService"
              >
                Aceptar
              </button>
              <button
                class="action-button action-primary"
                :disabled="insurerActionLoading || insurerTimeoutLocked || insurerTimeoutHandling"
                @click="rejectInsurerService"
              >
                Rechazar
              </button>
            </div>
          </div>

          <div class="insurer-modal-recommend">
            <div class="insurer-recommend">
              <div class="insurer-recommend__header">
                <h4>Recomendador de unidad</h4>
                <div class="insurer-recommend__actions">
                  <button
                    class="action-button"
                    @click="fetchRecommendationsForInsurer"
                    :disabled="insurerRecommendationLoading || insurerTimeoutLocked || insurerTimeoutHandling || !activeInsurerService.note_ident"
                  >
                    Recomendar
                  </button>
                </div>
              </div>
              <div class="insurer-recommend__hint">
                El recomendador muestra informacion completa de validacion al ejecutar <strong>Recomendar</strong>.
              </div>
              <table class="table insurer-recommend-table">
                <thead>
                  <tr>
                    <th class="insurer-rec-col-rank">#</th>
                    <th class="insurer-rec-col-unit">Unidad</th>
                    <th>Lat actual</th>
                    <th>Lon actual</th>
                    <th>Tiempo <small>min</small></th>
                    <th>Distancia <small>km</small></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(rec, idx) in insurerRecommendations"
                    :key="idx"
                    :class="{
                      'validation-row-best': idx < 5,
                      'validation-row-assigned': rec.has_assignment,
                      'validation-row-selected': selectedInsurerInlineUnit && selectedInsurerInlineUnit.unit === rec.unit
                    }"
                    :title="rec.has_assignment ? ('Servicio(s) asignado(s): ' + (rec.assigned_services || []).map(s => s.note_ident + (s.has_arrived ? ' (arribada)' : '')).join(', ')) : ''"
                    @click="selectInsurerInlineUnit(rec)"
                  >
                    <td class="insurer-rec-col-rank">{{ idx + 1 }}</td>
                    <td class="insurer-rec-col-unit" :title="rec.unit">
                      <span class="validation-unit-name">{{ rec.unit }}</span>
                      <span v-if="rec.has_assignment" class="validation-assigned-tag">Asignada</span>
                    </td>
                    <td>{{ rec.lat != null ? Number(rec.lat).toFixed(5) : '-' }}</td>
                    <td>{{ rec.lon != null ? Number(rec.lon).toFixed(5) : '-' }}</td>
                    <td>{{ rec.time_queue }}</td>
                    <td>{{ rec.distance_to_origin }}</td>
                  </tr>
                </tbody>
              </table>
              <div id="insurer-inline-validation-map" class="insurer-inline-map"></div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div v-if="showInsurerValidationModal" class="validation-overlay" @click="closeInsurerValidationModal">
      <div class="validation-content" @click.stop>
        <div class="validation-header">
          <div class="validation-header-titles">
            <h2 class="validation-title">Validacion de recomendacion</h2>
            <p class="validation-subtitle">Audita la ubicacion, tiempo de arribo y ruta sugerida de cada unidad</p>
          </div>
          <button class="validation-close-x" @click="closeInsurerValidationModal" aria-label="Cerrar">&times;</button>
        </div>
        <div class="validation-body">
          <div class="validation-map-wrapper">
            <div v-if="insurerValidationLoading" class="validation-loading">
              <span class="validation-spinner"></span>
              Cargando mapa y unidades...
            </div>
            <div id="insurer-validation-map" class="validation-map"></div>
            <div class="validation-legend">
              <span><i style="background:#d32f2f"></i> Origen del servicio</span>
              <span><i style="background:#1565c0"></i> Top 5 unidades</span>
              <span><i style="background:#ef6c00"></i> Paradas intermedias</span>
              <span><i style="background:#2e7d32"></i> Ruta seleccionada</span>
            </div>
          </div>
          <div class="validation-table-wrapper">
            <div class="validation-table-toolbar">
              <span class="validation-table-toolbar-title">Unidades candidatas</span>
              <span class="validation-count-badge">{{ insurerValidationUnits.length }}</span>
              <span class="validation-table-hint">Click en una unidad para ver su ruta</span>
            </div>
            <div class="validation-table-scroll">
              <table class="validation-table">
                <thead>
                  <tr>
                    <th class="vt-rank">#</th>
                    <th>Unidad</th>
                    <th>Distancia</th>
                    <th>Tiempo</th>
                    <th class="vt-num">Ocupa.</th>
                    <th class="vt-num">Asignac.</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(unit, idx) in insurerValidationUnits"
                    :key="unit.unit + '-' + idx"
                    :class="{
                      'validation-row-best': idx < 5,
                      'validation-row-assigned': unit.has_assignment,
                      'validation-row-selected': selectedInsurerValidationUnit && selectedInsurerValidationUnit.unit === unit.unit
                    }"
                    :title="unit.has_assignment ? ('Servicio(s) asignado(s): ' + unit.assigned_services.map(s => s.note_ident + (s.has_arrived ? ' (arribada)' : '')).join(', ')) : ''"
                    @click="selectInsurerValidationUnit(unit)"
                  >
                    <td class="vt-rank">
                      <span class="validation-rank" :class="{ 'validation-rank-top': idx < 5 }">{{ idx + 1 }}</span>
                    </td>
                    <td>
                      <span class="validation-unit-name">{{ unit.unit }}</span>
                      <span v-if="unit.has_assignment" class="validation-assigned-tag">Asignada</span>
                    </td>
                    <td>{{ unit.distance_to_origin ?? '-' }}</td>
                    <td>{{ unit.time_queue ?? '-' }}</td>
                    <td class="vt-num">{{ unit.occupation_time ?? '-' }}</td>
                    <td class="vt-num">{{ unit.number_assigned_services ?? '-' }}</td>
                  </tr>
                  <tr v-if="insurerValidationLoading">
                    <td colspan="6" class="validation-empty">Cargando unidades...</td>
                  </tr>
                  <tr v-if="!insurerValidationLoading && insurerValidationUnits.length === 0">
                    <td colspan="6" class="validation-empty">No hay unidades disponibles para validar.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="validation-footer">
          <button class="validation-btn-close" @click="closeInsurerValidationModal">Cerrar</button>
        </div>
      </div>
    </div>

    <div v-if="insurerToastQueue.length" class="insurer-toast-stack">
      <div
        v-for="service in insurerToastQueue"
        :key="service.id"
        class="insurer-toast insurer-toast--urgent"
        @click="openInsurerToastService(service)"
      >
        <div class="insurer-toast__alert">!</div>
        <button
          class="insurer-toast__dismiss"
          @click.stop="dismissInsurerToast(service.id)"
          aria-label="Cerrar notificación"
        >
          ×
        </button>
        <div class="insurer-toast__title">NUEVO SERVICIO DE PORTAL</div>
        <div class="insurer-toast__text">
          Expediente {{ service.expediente }}.
        </div>
        <div class="insurer-toast__meta">
          {{ service.insurer_payload?.tipoServicio || 'Servicio' }} · Click para tomarlo
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* ====== Tokens ====== */
.ops-modern {
  --brand: #f6bf2f;
  --brand-soft: #fdf3d6;
  --brand-ink: #3b2f0b;
  --ink: #16233b;
  --ink-deep: #0d1626;
  --muted: #5b6b82;
  --line: #dfe5ee;
  --line-strong: #c4cfde;
  --bg: #eef1f6;
  --card: #ffffff;
  --accent: #2563eb;
  --radius-lg: 16px;
  --radius-md: 12px;
  --radius-sm: 8px;
  --shadow-1: 0 1px 2px rgba(22, 35, 59, 0.05), 0 12px 28px -14px rgba(22, 35, 59, 0.14);
  --shadow-2: 0 1px 3px rgba(22, 35, 59, 0.1);
}

/* Base bg */
.ops-modern {
  background:
    radial-gradient(1100px 360px at 50% -120px, rgba(246, 191, 47, 0.12), transparent 60%),
    linear-gradient(180deg, #f3f6fa 0%, var(--bg) 280px);
  min-height: 100vh;
  color: var(--ink);
  -webkit-font-smoothing: antialiased;
}

/* Navbar (keeps your logo) */
.ops-modern .nav-bar-operations {
  position: sticky; top: 0; left: 0; width: 100%;
  height: 10vh;
  background: linear-gradient(180deg, #ffd158 0%, var(--brand) 100%);
  border-bottom: 1px solid rgba(59, 47, 11, 0.18);
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 8px 20px -10px rgba(22, 35, 59, 0.28);
  z-index: 1000;
}
.ops-modern .logo-button { height: 70%; cursor: pointer; }

/* Tabs → Soft pills */
.ops-modern .nav.nav-tabs {
  border: none;
  display: flex; gap: 8px; flex-wrap: wrap;
  background: transparent;
  margin: 16px auto 8px;
  padding: 0 12px;
}
.ops-modern .nav.nav-tabs .nav-item { margin: 0; }
.ops-modern .nav.nav-tabs .nav-link {
  border: 1px solid #a9b6ca !important;
  background: var(--card);
  color: var(--ink);
  border-radius: 999px !important;
  padding: 8px 14px;
  font-weight: 700;
  box-shadow: 0 1px 3px rgba(22, 35, 59, 0.14), 0 3px 8px -4px rgba(22, 35, 59, 0.18);
  transition: transform .12s ease, box-shadow .12s ease, background .12s, color .12s, border-color .12s;
}
.ops-modern .nav.nav-tabs .nav-link:hover {
  transform: translateY(-1px);
  color: var(--ink-deep);
  background: var(--brand-soft);
  border-color: var(--brand) !important;
  box-shadow: 0 4px 10px -4px rgba(22, 35, 59, 0.35);
}
.ops-modern .nav.nav-tabs .nav-link.active {
  background: linear-gradient(180deg, #22334e, var(--ink));
  color: #ffd75e;
  border-color: var(--ink-deep) !important;
  box-shadow: 0 8px 16px -8px rgba(22, 35, 59, 0.55);
}

/* Head strip with thermometer */
.card-strip {
  background: linear-gradient(180deg, #ffffff, #fbfcfe);
  border: 1px solid var(--line);
  border-left: 4px solid var(--brand);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-1);
  padding: 10px 14px;
  margin: 8px 12px 12px;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 12px;
  align-items: center;
}
.text-operations {
  border: 0; height: auto; font-size: 20px;
  display: contents;
}
.text-operations h2 {
  margin: 0; color: var(--ink); font-size: 1.1rem; font-weight: 800;
  letter-spacing: -0.01em;
  font-variant-numeric: tabular-nums;
}
.status-counts {
  text-align: right; font-size: .85rem; color: var(--muted);
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}

.thermometer {
  grid-column: 1 / -1;
  height: 14px;
  background: #e4eaf3;
  border-radius: 999px;
  display: flex; overflow: hidden;
  border: 1px solid var(--line-strong);
  box-shadow: inset 0 1px 2px rgba(22, 35, 59, 0.12);
}
.bar { height: 100%; }
.bar.active { background: linear-gradient(180deg, #22c55e, #15803d); }
.bar.cancelled { background: linear-gradient(180deg, #ef4444, #b91c1c); }
.bar.scheduled { background: linear-gradient(180deg, #8b5cf6, #6d28d9); }
.bar.assigned { background: linear-gradient(180deg, #f59e0b, #b45309); }
.bar.completed { background: linear-gradient(180deg, #3b82f6, #1d4ed8); }

.status-count-bubble {
  background: rgba(13, 22, 38, 0.94); color: #f8fafc;
  padding: 6px 10px; border-radius: 8px; font-size: .85rem;
  box-shadow: var(--shadow-2);
}

/* Action buttons row */
.action-buttons {
  display: flex; justify-content: flex-end; gap: 8px;
  margin: 10px 12px 0;
}
.action-button {
  padding: 8px 16px;
  border: 1px solid rgba(22, 35, 59, 0.22);
  background: rgba(255, 255, 255, 0.92);
  color: var(--ink);
  border-radius: 999px;
  font-weight: 700;
  letter-spacing: 0.01em;
  box-shadow: 0 2px 6px -2px rgba(22, 35, 59, 0.3);
  backdrop-filter: blur(6px);
  transition: transform .12s, box-shadow .12s, background .12s, border-color .12s;
}
.action-button:hover {
  transform: translateY(-1px);
  background: #ffffff;
  border-color: rgba(22, 35, 59, 0.45);
  box-shadow: 0 8px 16px -8px rgba(22, 35, 59, 0.5);
}
.action-primary {
  background: linear-gradient(180deg, #22334e, var(--ink));
  color: #ffd75e;
  border-color: var(--ink-deep);
}
.action-primary::before {
  content: "+";
  margin-right: 6px;
  font-weight: 900;
}
.action-primary:hover {
  background: linear-gradient(180deg, #2a3d5c, #1b2a45);
  border-color: var(--ink-deep);
}

/* Toolbar layout: on wide screens the action buttons dock inside the yellow
   top bar (fixed, so they track the sticky navbar), vertically centered and
   right-aligned. Below the breakpoint they fall back to their own row. */
@media (min-width: 1200px) {
  .action-buttons {
    position: fixed;
    top: 5vh; /* half of the 10vh navbar */
    right: 16px;
    transform: translateY(-50%);
    margin: 0;
    z-index: 1010; /* above the navbar (1000), below modals */
  }
  .ops-modern.compact .action-buttons {
    top: 4vh; /* half of the 8vh compact navbar */
    right: 12px;
    margin: 0;
  }
}

/* Card wrapper for tables */
.card-wrap {
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-1);
  padding: 12px;
  margin: 12px;
}
.card-wrap > h2 {
  margin: 4px 6px 10px; font-size: 1rem; font-weight: 800; color: var(--ink);
  display: flex; align-items: center; gap: 8px;
  letter-spacing: -0.01em;
}
.card-wrap > h2::before {
  content: "";
  width: 8px; height: 8px; border-radius: 3px;
  background: var(--brand);
  box-shadow: 0 0 0 3px var(--brand-soft);
  flex: 0 0 auto;
}

/* Tables */
.table-container { overflow-x: auto; }
.table {
  width: 100%;
  border-collapse: separate; border-spacing: 0;
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: var(--radius-md);
  overflow: hidden;
  box-shadow: var(--shadow-2);
  font-size: .85rem;
}
.table thead th {
  position: sticky; top: 0; z-index: 1;
  background-color: #ffe08a;
  color: var(--brand-ink);
  font-weight: 800;
  font-size: .92em;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid #ecc554;
  padding: 6px 8px;
  white-space: nowrap;
}
/* Header column separators: short centered ticks, softer than full lines */
.table thead th:not(:last-child) {
  background-image: linear-gradient(rgba(59, 47, 11, 0.28), rgba(59, 47, 11, 0.28));
  background-size: 1px 55%;
  background-repeat: no-repeat;
  background-position: right center;
}
.table thead th input,
.table thead th select {
  margin-top: 6px; padding: 6px 8px; width: 100%;
  border: 1px solid var(--line-strong); border-radius: 8px; background: #fff;
  color: var(--ink);
  font-weight: 500;
  text-transform: none;
  letter-spacing: normal;
}
.table tbody td {
  padding: 10px 12px; border-bottom: 1px solid #eceff5;
  color: var(--ink); vertical-align: top; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.01em;
  /* soft vertical column separator */
  box-shadow: inset -1px 0 0 #e4e9f2;
}
.table tbody td:last-child { box-shadow: none; }
.table tbody tr:last-child td { border-bottom: none; }
.table tbody tr:nth-child(even) td { background: #f8fafd; }
.table tbody tr:hover td { background: #eaf1fd; color: var(--ink); }

/* Route tables (Origen → Destino): merge the two location columns visually.
   No separator between them; a flow arrow bridges origin to destination. */
.table--route thead th:nth-child(4) { background-image: none; }
.table--route tbody td:nth-child(4) {
  box-shadow: none;
  position: relative;
  padding-right: 24px;
}
.table--route tbody td:nth-child(4)::after {
  content: "➜";
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  color: #8fa0b8;
  font-size: 0.92em;
  line-height: 1;
  pointer-events: none;
}
.table--route tbody tr:hover td:nth-child(4)::after { color: var(--accent); }
/* Cancelled: static red, terminal state — no motion, red text like the pills */
.table tbody tr.row-cancelado-glow td,
.table tbody tr.row-cancelado-glow:nth-child(even) td {
  background: #fdecec;
  color: #b91c1c;
  box-shadow: inset -1px 0 0 #f5cfcf;
}
.table tbody tr.row-cancelado-glow td:last-child { box-shadow: none; }
.table tbody tr.row-cancelado-glow:hover td { background: #fbdfdf; color: #991b1b; }

/* Insurer-pending: orange pulse (needs insurer action) */
.table tbody tr.row-insurer-pending-glow td {
  animation: insurerPendingRowGlow 1.6s ease-in-out infinite;
}

/* Past ETA without registered arrival: fast red blink — act now */
.table tbody tr.row-overdue-glow td {
  animation: overdueRowGlow 0.8s ease-in-out infinite;
}

/* Semantic emphasis for dense table scanning (no spacing changes) */
.table tbody td:nth-child(1),
.table tbody td:nth-child(10),
.table tbody td:nth-child(11),
.table tbody td:nth-child(12) {
  color: var(--muted);
}
.table tbody td:nth-child(3),
.table tbody td:nth-child(4),
.table tbody td:nth-child(5) {
  color: #0b1323;
}
.table tbody td:nth-child(2),
.table tbody td:nth-child(6),
.table tbody td:nth-child(7),
.table tbody td:nth-child(8),
.table tbody td:nth-child(9),
.table tbody td:nth-child(10),
.table tbody td:nth-child(12),
.table tbody td:nth-child(13) {
  text-align: center;
}

.table {
table-layout: fixed;
font-size: .85rem;
}
/* wide (wordy) columns */
.table td:nth-child(4),
.table th:nth-child(4),   /* Origen */
.table td:nth-child(5),
.table th:nth-child(5) {  /* Destino */
width: 100px;
max-width: 100px;
}

.table td:nth-child(3),
.table th:nth-child(3) {  
width: 10%;
max-width: 10%;
}   /* Cliente */

/* tight (short) columns */
.table td:nth-child(1),  .table th:nth-child(1),   /* ID */
.table td:nth-child(6),  .table th:nth-child(6),   /* Hora inicio */
.table td:nth-child(7),  .table th:nth-child(7),   /* Hora contacto */
.table td:nth-child(8),  .table th:nth-child(8),   /* Unidad */
.table td:nth-child(9),  .table th:nth-child(9),   /* Operador */
.table td:nth-child(10), .table th:nth-child(10),  /* Expediente */
.table td:nth-child(12), .table th:nth-child(12),  /* Tipo */
.table td:nth-child(13), .table th:nth-child(13) { /* Estatus */
width: 5%;
max-width: 5%;
white-space: nowrap;
}

.table--workorders { table-layout: fixed; }

/* map:
1 ID | 2 Solicitud | 3 Cliente | 4 Inicio | 5 Contacto | 6 Unidad | 7 Operador | 8 Expediente | 9 Capturista | 10 Sucursal */
.table--workorders tbody td:nth-child(1),
.table--workorders tbody td:nth-child(8),
.table--workorders tbody td:nth-child(9) {
  color: var(--muted);
}
.table--workorders tbody td:nth-child(2),
.table--workorders tbody td:nth-child(4),
.table--workorders tbody td:nth-child(5),
.table--workorders tbody td:nth-child(6),
.table--workorders tbody td:nth-child(7),
.table--workorders tbody td:nth-child(8) {
  text-align: center;
}

/* wordy + date/time */
.table--workorders td:nth-child(2), .table--workorders th:nth-child(2) { width: 170px; max-width: 170px; } /* Solicitud (fecha+hora) */
.table--workorders td:nth-child(3), .table--workorders th:nth-child(3) { width: 160px; max-width: 160px; } /* Cliente */
.table--workorders td:nth-child(9), .table--workorders th:nth-child(9) { width: 140px; max-width: 140px; } /* Capturista */
.table--workorders td:nth-child(10), .table--workorders th:nth-child(10) { width: 140px; max-width: 140px; } /* Sucursal */

/* tight (collapse hard) */
.table--workorders td:nth-child(1),  .table--workorders th:nth-child(1),  /* ID */
.table--workorders td:nth-child(4),  .table--workorders th:nth-child(4),  /* Inicio */
.table--workorders td:nth-child(5),  .table--workorders th:nth-child(5),  /* Contacto */
.table--workorders td:nth-child(6),  .table--workorders th:nth-child(6),  /* Unidad */
.table--workorders td:nth-child(7),  .table--workorders th:nth-child(7),  /* Operador */
.table--workorders td:nth-child(8),  .table--workorders th:nth-child(8)   /* Expediente */ {
width: 5%; max-width: 5%;
}

/* responsive nudges (optional) */
@media (max-width: 1360px) {
.table--workorders td:nth-child(3), .table--workorders th:nth-child(3) { width: 140px; max-width: 140px; }
.table--workorders td:nth-child(9), .table--workorders th:nth-child(9),
.table--workorders td:nth-child(10), .table--workorders th:nth-child(10) { width: 120px; max-width: 120px; }
}
@media (max-width: 1200px) {
.table--workorders { font-size: .8rem; }
.table--workorders tbody td { padding: 8px 10px; }
}

/* Note chip: ETA urgency color arrives via --eta (set inline per row).
   Light tinted badge + dark colored text + status dot = readable at a glance. */
.note-pill {
  --eta: #64748b;
  display: inline-flex; align-items: center; justify-content: center;
  color: var(--eta);
  background: #ffffff;
  border: 1px solid var(--eta);
  font-weight: 800;
  font-size: 0.88rem;
  line-height: 1;
  padding: 3px 9px; border-radius: 999px; cursor: pointer;
  box-shadow: var(--shadow-2);
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.02em;
  transition: transform .12s ease, box-shadow .12s ease;
}
@supports (color: color-mix(in srgb, red 50%, white)) {
  .note-pill {
    /* vivid tint + darker version of the pill's own color for the text */
    color: color-mix(in srgb, var(--eta) 72%, #000000);
    background: color-mix(in srgb, var(--eta) 20%, #ffffff);
    border-color: color-mix(in srgb, var(--eta) 60%, #ffffff);
    box-shadow: 0 1px 4px color-mix(in srgb, var(--eta) 30%, transparent);
  }
}
.note-pill:hover {
  transform: translateY(-1px);
  box-shadow: 0 5px 12px -3px rgba(22, 35, 59, 0.5);
}

/* Status chips */
.status {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 4px 10px; border-radius: 999px; font-weight: 700; font-size: .85rem;
  border: 1px solid transparent;
  letter-spacing: 0.01em;
}
.status::before {
  content: "";
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.65);
  animation: statusDotPulse 1.8s ease-in-out infinite;
}
@keyframes statusDotPulse {
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.35); opacity: 0.55; }
}
.status--ok { background: #d1fae5; color: #047857; border-color: #34d399; }
.status--warn { background: #fde68a; color: #92400e; border-color: #f59e0b; }
.status--danger { background: #fecaca; color: #dc2626; border-color: #f87171; }
.status--info { background: #bfdbfe; color: #1d4ed8; border-color: #60a5fa; }

/* Pagination */
.pagination-container {
  display: flex; justify-content: center; align-items: center;
  gap: 8px; margin: 12px 0 4px;
}
.pagination-container button {
  padding: 6px 8px; background: transparent; border: none; cursor: pointer;
  border-radius: 8px;
  transition: background .12s;
}
.pagination-container button:hover:not(:disabled) { background: #e8edf5; }
.pagination-container button:disabled { opacity: .35; cursor: not-allowed; }
.pagination-container span {
  min-width: 32px; text-align: center; padding: 6px 8px; cursor: pointer;
  border-radius: 10px; border: 1px solid var(--line); background: var(--card); font-weight: 700;
  color: var(--muted);
  transition: color .12s, border-color .12s, background .12s;
}
.pagination-container span:hover { color: var(--ink); border-color: var(--line-strong); }
.pagination-container span.active {
  background: var(--ink); color: #ffd75e; border-color: var(--ink-deep);
  box-shadow: 0 4px 10px -5px rgba(22, 35, 59, 0.55);
}

/* sort button */
.sort-btn {
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0 0 0 6px;
  font-size: .85em;
  line-height: 1;
  color: rgba(59, 47, 11, 0.55);
  transition: color .12s;
}
.sort-btn span {
  font-weight: 800;
  display: inline-block;
  min-width: 0.9em;
  text-align: center;
}
.table thead th:hover .sort-btn,
.sort-btn:focus-visible {
  color: var(--brand-ink); /* darkens to full strength on the yellow header */
}
.ops-modern .nav.nav-tabs .nav-link:focus-visible,
.action-button:focus-visible,
.pagination-container span:focus-visible,
.sort-btn:focus-visible {
  outline: 2px solid #1d4ed8;
  outline-offset: 2px;
}


/* Responsive */
@media (max-width: 920px) {
  .ops-modern .nav.nav-tabs { justify-content: center; }
  .table thead th { position: static; }
}

@media (prefers-reduced-motion: reduce) {
  .ops-modern .nav.nav-tabs .nav-link,
  .action-button {
    transition: none;
  }
  .status::before {
    animation: none;
  }
  .table tbody tr.row-overdue-glow td,
  .table tbody tr.row-insurer-pending-glow td {
    animation: none;
  }
  .table tbody tr.row-overdue-glow td {
    background-color: rgba(239, 68, 68, 0.18);
    box-shadow: inset 0 0 0 1px rgba(220, 38, 38, 0.45);
  }
  .table tbody tr.row-insurer-pending-glow td {
    background-color: rgba(251, 146, 60, 0.18);
    box-shadow: inset 0 0 0 1px rgba(234, 88, 12, 0.4);
  }
}

@keyframes overdueRowGlow {
  0%, 100% {
    background-color: rgba(239, 68, 68, 0.08);
    box-shadow: inset 0 0 0 1px rgba(220, 38, 38, 0.28);
  }
  50% {
    background-color: rgba(239, 68, 68, 0.26);
    box-shadow: inset 0 0 0 1px rgba(220, 38, 38, 0.6);
  }
}
@keyframes insurerPendingRowGlow {
  0%, 100% {
    background-color: rgba(251, 146, 60, 0.12);
    box-shadow: inset 0 0 0 1px rgba(234, 88, 12, 0.34);
  }
  50% {
    background-color: rgba(251, 146, 60, 0.24);
    box-shadow: inset 0 0 0 1px rgba(234, 88, 12, 0.52);
  }
}

/* ========== COMPACT MODE (drop-in) ========== */
.ops-modern.compact .nav-bar-operations { height: 8vh; }
.ops-modern.compact .logo-button { height: 60%; }
.ops-modern.compact [style*="padding-top: 90px"] { padding-top: 72px !important; }

/* Tabs smaller */
.ops-modern.compact .nav.nav-tabs { margin: 10px auto 6px; padding: 0 8px; gap: 6px; }
.ops-modern.compact .nav.nav-tabs .nav-link {
  padding: 6px 10px;
  font-size: .85rem;
  border-radius: 999px !important;
  box-shadow: 0 1px 4px rgba(0,0,0,.06);
}

/* Head strip + thermometer tighter */
.ops-modern.compact .card-strip { padding: 8px 10px; margin: 6px 8px 8px; gap: 8px; }
.ops-modern.compact .text-operations h2 { font-size: .95rem; }
.ops-modern.compact .status-counts { font-size: .75rem; }
.ops-modern.compact .thermometer { height: 10px; }

/* Action buttons smaller */
.ops-modern.compact .action-buttons { margin: 8px 8px 0; gap: 6px; }
.ops-modern.compact .action-button {
  padding: 6px 14px;
  font-size: .85rem;
  border-radius: 999px;
}

/* Cards tighter */
.ops-modern.compact .card-wrap { padding: 8px; margin: 8px; }
.ops-modern.compact .card-wrap > h2 { margin: 2px 4px 6px; font-size: .95rem; }

/* Table density */
.ops-modern.compact .table {
  font-size: 0.65rem;          /* shrink font */
  line-height: 1.1;            /* reduce row height */
}

.ops-modern.compact .table thead th {
  padding: 4px 6px;            /* tighter header */
  font-size: 0.68rem;
}

.ops-modern.compact .table thead th input,
.ops-modern.compact .table thead th select {
  padding: 2px 4px;            /* very small filter boxes */
  font-size: 0.65rem;
}

.ops-modern.compact .table tbody td {
  padding: 3px 6px;            /* less padding = thinner rows */
  font-size: 0.65rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ops-modern.compact .table--route tbody td:nth-child(4) {
  padding-right: 16px;         /* room for the origin → destination arrow */
}
.ops-modern.compact .table--route tbody td:nth-child(4)::after {
  right: 3px;
}

/* Status & note chips smaller too (but keep the ID legible) */
.ops-modern.compact .note-pill {
  padding: 0 6px;
  font-size: 0.7rem;
  line-height: 1.2;
}
.ops-modern.compact .status {
  padding: 1px 6px;
  font-size: 0.62rem;
}
.ops-modern.compact .status::before {
  width: 5px; height: 5px;
}

/* Pagination smaller */
.ops-modern.compact .pagination-container { gap: 6px; margin: 8px 0 2px; }
.ops-modern.compact .pagination-container span { min-width: 26px; padding: 4px 6px; font-size: .8rem; }
.ops-modern.compact .pagination-container button img { width: 18px; }

/* Mobile: keep compact feel */
@media (max-width: 920px) {
  .ops-modern.compact .table thead th { position: static; }
}

.insurer-notifications {
  margin: 12px;
}
.insurer-notifications__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}
.insurer-notifications__list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 10px;
}
.insurer-notification-item {
  text-align: left;
  border: 1px solid var(--line);
  border-radius: var(--radius-md);
  background: #f8fafc;
  padding: 10px;
}
.insurer-notification-item__title {
  font-weight: 800;
  color: var(--ink);
}
.insurer-notification-item__meta {
  font-size: 0.8rem;
  color: var(--muted);
}
.insurer-notifications__empty {
  margin-top: 10px;
  color: var(--muted);
}
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
}
.modal-card {
  background: #fff;
  border-radius: 12px;
  padding: 18px;
  width: min(900px, 95vw);
  max-height: 90vh;
  overflow: auto;
}
.insurer-modal-card h3 {
  margin-top: 0;
}
.insurer-modal-card--wide {
  width: min(1420px, 98vw);
}
.insurer-modal-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.08fr) minmax(0, 1fr);
  gap: 18px;
}
.insurer-modal-main,
.insurer-modal-recommend {
  min-width: 0;
}
.insurer-modal-main {
  border-right: 1px solid #e2e8f0;
  padding-right: 14px;
}
.insurer-service-type {
  margin: 8px 0 10px 0;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid #f59e0b;
  background: #fef3c7;
  color: #7c2d12;
}
.insurer-service-type__label {
  display: block;
  font-size: 0.76rem;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  opacity: 0.9;
}
.insurer-service-type__value {
  display: block;
  margin-top: 2px;
  font-size: 0.95rem;
}
.insurer-countdown {
  font-size: 1rem;
  font-weight: 700;
  color: #7f1d1d;
  background: #fee2e2;
  border: 1px solid #fca5a5;
  border-radius: 8px;
  padding: 8px 10px;
  margin: 8px 0 10px 0;
}
.insurer-countdown--warning {
  color: #9a3412;
  background: #ffedd5;
  border-color: #fdba74;
}
.insurer-countdown--expired {
  color: #991b1b;
  background: #fecaca;
  border-color: #ef4444;
}
.insurer-assign-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin: 14px 0;
}
.insurer-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.insurer-field--full {
  grid-column: 1 / -1;
}
.insurer-field input,
.insurer-field select {
  border: 1px solid var(--line);
  border-radius: 8px;
  padding: 6px 8px;
}
.insurer-resolved {
  font-size: 0.78rem;
}
.insurer-resolved.ok {
  color: #166534;
}
.insurer-resolved.err {
  color: #b91c1c;
}
.insurer-recommend__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}
.insurer-recommend__actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.insurer-recommend__hint {
  margin-top: 6px;
  color: #475569;
  font-size: 0.82rem;
}
.insurer-recommend-table {
  margin-top: 8px;
  width: 100%;
  table-layout: auto;
}
.insurer-recommend-table th,
.insurer-recommend-table td {
  white-space: nowrap;
}
.insurer-rec-col-rank {
  width: 44px;
  text-align: center;
}
.insurer-rec-col-unit {
  min-width: 140px;
}
.insurer-inline-map {
  margin-top: 10px;
  width: 100%;
  height: 360px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
}
.insurer-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
}
.insurer-toast-stack {
  position: fixed;
  right: 18px;
  bottom: 18px;
  width: min(390px, calc(100vw - 24px));
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 3200;
}
.insurer-toast {
  position: relative;
  background: #fee2e2;
  color: #7f1d1d;
  border-radius: 12px;
  padding: 14px 16px 12px 16px;
  box-shadow: 0 12px 28px rgba(127, 29, 29, 0.25);
  cursor: pointer;
  border: 2px solid #7f1d1d;
  overflow: hidden;
}
.insurer-toast--urgent {
  animation: insurerToastPulse 1s ease-in-out infinite;
}
.insurer-toast__alert {
  position: absolute;
  top: -10px;
  left: -10px;
  width: 42px;
  height: 42px;
  border-radius: 999px;
  background: #fee2e2;
  color: #991b1b;
  border: 2px solid #7f1d1d;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: 900;
  box-shadow: 0 6px 16px rgba(127, 29, 29, 0.45);
}
.insurer-toast__dismiss {
  position: absolute;
  top: 6px;
  right: 8px;
  width: 26px;
  height: 26px;
  border: none;
  border-radius: 999px;
  background: rgba(127, 29, 29, 0.12);
  color: #7f1d1d;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
}
.insurer-toast__title {
  font-weight: 900;
  letter-spacing: 0.08em;
  margin-bottom: 2px;
  padding-left: 30px;
}
.insurer-toast__text {
  font-size: 0.88rem;
  font-weight: 700;
  padding-left: 30px;
}
.insurer-toast__meta {
  margin-top: 6px;
  font-size: 0.78rem;
  opacity: 0.95;
  padding-left: 30px;
}
@media (max-width: 1080px) {
  .insurer-modal-layout {
    grid-template-columns: 1fr;
  }
  .insurer-modal-main {
    border-right: none;
    padding-right: 0;
    border-bottom: 1px solid #e2e8f0;
    padding-bottom: 10px;
    margin-bottom: 4px;
  }
}

/* Recommendation validation modal */
.validation-overlay {
  position: fixed;
  inset: 0;
  z-index: 4000;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
}
.validation-content {
  width: min(1200px, 96vw);
  max-height: 92vh;
  background: #fff;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.validation-header {
  padding: 16px 20px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.validation-header-titles {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.validation-title {
  margin: 0;
  font-size: 1.05rem;
  color: #0f172a;
}
.validation-subtitle {
  margin: 0;
  color: #475569;
  font-size: 0.86rem;
}
.validation-close-x {
  border: none;
  background: transparent;
  color: #475569;
  font-size: 1.7rem;
  line-height: 1;
  cursor: pointer;
}
.validation-body {
  padding: 16px;
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(0, 1fr);
  gap: 14px;
  overflow: auto;
}
.validation-map-wrapper {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
}
.validation-map {
  width: 100%;
  height: 480px;
  background: #f8fafc;
}
.validation-loading {
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 10px;
  font-size: 0.86rem;
  color: #334155;
}
.validation-spinner {
  width: 14px;
  height: 14px;
  border-radius: 999px;
  border: 2px solid #cbd5e1;
  border-top-color: #0f172a;
  animation: insurer-validation-spin 0.8s linear infinite;
}
@keyframes insurer-validation-spin {
  to { transform: rotate(360deg); }
}
.validation-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px;
  border-top: 1px solid #e2e8f0;
  font-size: 0.78rem;
  color: #334155;
}
.validation-legend span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.validation-legend i {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 999px;
}
.validation-table-wrapper {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  display: flex;
  flex-direction: column;
}
.validation-table-toolbar {
  padding: 10px 12px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.validation-table-toolbar-title {
  font-weight: 700;
  color: #0f172a;
}
.validation-count-badge {
  background: #e2e8f0;
  color: #0f172a;
  border-radius: 999px;
  padding: 2px 8px;
  font-size: 0.74rem;
  font-weight: 700;
}
.validation-table-hint {
  color: #64748b;
  font-size: 0.74rem;
}
.validation-table-scroll {
  max-height: 530px;
  overflow: auto;
}
.validation-table {
  width: 100%;
  border-collapse: collapse;
}
.validation-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #f8fafc;
  color: #0f172a;
  font-size: 0.74rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  border-bottom: 1px solid #e2e8f0;
  padding: 8px;
  text-align: left;
}
.validation-table th.vt-num,
.validation-table td.vt-num,
.validation-table th.vt-rank,
.validation-table td.vt-rank {
  text-align: center;
}
.validation-table tbody td {
  padding: 8px;
  border-bottom: 1px solid #f1f5f9;
  font-size: 0.84rem;
}
.validation-table tbody tr {
  cursor: pointer;
}
.validation-table tbody tr:hover {
  background: #f8fafc;
}
.validation-rank {
  display: inline-flex;
  width: 22px;
  height: 22px;
  border-radius: 999px;
  align-items: center;
  justify-content: center;
  background: #cbd5e1;
  color: #0f172a;
  font-size: 0.73rem;
  font-weight: 700;
}
.validation-rank-top {
  background: #1565c0;
  color: #fff;
}
.validation-unit-name {
  font-weight: 700;
}
.validation-row-best {
  background: #f8fbff;
}
.validation-row-assigned td:first-child {
  border-left: 3px solid #ea580c;
}
.validation-row-selected {
  background: #dcfce7 !important;
}
.validation-row-selected td:first-child {
  border-left: 3px solid #2e7d32;
}
.validation-assigned-tag {
  margin-left: 6px;
  font-size: 0.68rem;
  color: #9a3412;
  background: #ffedd5;
  border: 1px solid #fdba74;
  padding: 1px 5px;
  border-radius: 999px;
}
.validation-empty {
  text-align: center;
  color: #64748b;
  padding: 12px;
}
.validation-footer {
  padding: 12px 16px;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
}
.validation-btn-close {
  border: 1px solid #334155;
  background: #fff;
  color: #334155;
  border-radius: 8px;
  padding: 7px 14px;
  font-weight: 700;
  cursor: pointer;
}
@keyframes insurerToastPulse {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-2px); }
}

</style>

<script>
/* global google */
import axios from 'axios';
import Swal from 'sweetalert2';

export default {
  data() {
    return {
      activeTab: 'tab5', // Default active tab
      assistanceStatusCounts: { Activo: 1, Cancelado: 1, Programado: 1, Completado: 1, Asignada: 1 },
      auxiliarStatusCounts: { Activo: 1, Cancelado: 1, Programado: 1, Completado: 1, Asignada: 1 },
      lotStatusCounts: { Activo: 1, Cancelado: 1, Programado: 1, Completado: 1, Asignada: 1 },
      InProgressStatusCounts: { Activo: 1, Cancelado: 1, Programado: 1, Completado: 1, Asignada: 1 },
      ScheduledStatusCounts: { Activo: 0, Cancelado: 0, Programado: 0, Completado: 0, Asignada: 0 },
      inLotStatusCounts: { Activo: 1, Cancelado: 1, Programado: 1, Completado: 1, Asignada: 1 },

      assistanceHoverStatusCount: '',
      auxiliarHoverStatusCount: '',
      lotHoverStatusCount: '',
      hoverStatusCountStyle: { position: 'absolute', top: 0, left: 0 },

      assistanceFilters: { status : ["1","5"], type: ["2"] },
      auxiliarFilters: { status : ["1","5"], type: ["1"] },
      lotFilters: { status : ["1","5"], type: ["4"] },
      InProgressAllFilters: { status : ["1","5"], type: ["1", "2", "3", "4", "5"] },
      inLotFilters: { in_lot : [true] },

      assistanceCurrentPage: 1,
      assistanceCurrentScheduledPage: 1,
      assistancePageSize: 30,
      assistancePageSizeScheduled: 20,
      assistanceScheduledOrders: [],
      assistanceInProcessOrders: [],
      assistanceOriginalOrders: [],
      assistance_n_inProcessOrders: 0,
      assistance_n_scheduledOrders: 0,

      auxiliarCurrentPage: 1,
      auxiliarCurrentScheduledPage: 1,
      auxiliarPageSize: 30,
      auxiliarPageSizeScheduled: 20,
      auxiliarScheduledOrders: [],
      auxiliarInProcessOrders: [],
      auxiliarOriginalOrders: [],
      auxiliar_n_inProcessOrders: 0,
      auxiliar_n_scheduledOrders: 0,

      lotCurrentPage: 1,
      lotCurrentScheduledPage: 1,
      lotPageSize: 30,
      lotPageSizeScheduled: 20,
      lotScheduledOrders: [],
      lotInProcessOrders: [],
      lotOriginalOrders: [],
      lot_n_inProcessOrders: 0,
      lot_n_scheduledOrders: 0,

      forkliftStatusCounts: { Activo: 1, Cancelado: 1, Programado: 1, Completado: 1, Asignada: 1 },
      forkliftHoverStatusCount: '',
      forkliftHoverStatusCountStyle: { position: 'absolute', top: 0, left: 0 },
      forkliftFilters: { status : ["1","5"], type: ["3"] },
      industrialStatusCounts: { Activo: 1, Cancelado: 1, Programado: 1, Completado: 1, Asignada: 1 },
      industrialHoverStatusCount: '',
      industrialHoverStatusCountStyle: { position: 'absolute', top: 0, left: 0 },
      industrialFilters: { status : ["1","5"], type: ["5"] },
      forkliftCurrentPage: 1,
      forkliftCurrentScheduledPage: 1,
      forkliftPageSize: 30,
      forkliftPageSizeScheduled: 20,
      forkliftScheduledOrders: [],
      forkliftInProcessOrders: [],
      forkliftOriginalOrders: [],
      forklift_n_inProcessOrders: 0,
      forklift_n_scheduledOrders: 0,

      industrialCurrentPage: 1,
      industrialCurrentScheduledPage: 1,
      industrialPageSize: 30,
      industrialPageSizeScheduled: 20,
      industrialScheduledOrders: [],
      industrialInProcessOrders: [],
      industrialOriginalOrders: [],
      industrial_n_inProcessOrders: 0,
      industrial_n_scheduledOrders: 0,

      InProgressCurrentPage: 1,
      InProgressPageSize: 1000,
      InProcessOrders: [],
      n_inProcessOrders: 0,
      OriginalOrders: [],

      scheduledCurrentPage: 1,
      scheduledPageSize: 50,
      scheduledOrders: [],
      n_scheduledOrders: 0,
      OriginalScheduledOrders: 0,

      InLotCurrentPage: 1,
      InLotPageSize: 1000,
      InLotOrders: [],
      n_inLotOrders: 0,
      inLotOrders: [],

      /* ---------- SORT STATE (per table) ---------- */
      sortState: {
        assistance: { by: 'request_time', dir: 'desc' },
        assistanceScheduled: { by: 'request_time', dir: 'desc' },
        auxiliar: { by: 'request_time', dir: 'desc' },
        auxiliarScheduled: { by: 'request_time', dir: 'desc' },
        lot: { by: 'request_time', dir: 'desc' },
        lotScheduled: { by: 'request_time', dir: 'desc' },
        forklift: { by: 'request_time', dir: 'desc' },
        forkliftScheduled: { by: 'request_time', dir: 'desc' },
        industrial: { by: 'request_time', dir: 'desc' },
        industrialScheduled: { by: 'request_time', dir: 'desc' },
        allInProcess: { by: 'request_time', dir: 'desc' },
        allScheduled: { by: 'scheduled_for', dir: 'desc' },
        allInLot: { by: 'request_time', dir: 'desc' },
      },

      /* link sort keys to page + fetch, used by toggleSort */
      tableConfig: {
        assistance: { pageProp: 'assistanceCurrentPage', fetch: 'fetchInProcessAssistance' },
        assistanceScheduled: { pageProp: 'assistanceCurrentScheduledPage', fetch: 'fetchScheduledAssistance' },
        auxiliar: { pageProp: 'auxiliarCurrentPage', fetch: 'fetchInProcessAuxiliar' },
        auxiliarScheduled: { pageProp: 'auxiliarCurrentScheduledPage', fetch: 'fetchScheduledAuxiliar' },
        lot: { pageProp: 'lotCurrentPage', fetch: 'fetchInProcessLot' },
        lotScheduled: { pageProp: 'lotCurrentScheduledPage', fetch: 'fetchScheduledLot' },
        forklift: { pageProp: 'forkliftCurrentPage', fetch: 'fetchInProcessForklift' },
        forkliftScheduled: { pageProp: 'forkliftCurrentScheduledPage', fetch: 'fetchScheduledForklift' },
        industrial: { pageProp: 'industrialCurrentPage', fetch: 'fetchInProcessIndustrial' },
        industrialScheduled: { pageProp: 'industrialCurrentScheduledPage', fetch: 'fetchScheduledIndustrial' },
        allInProcess: { pageProp: 'InProgressCurrentPage', fetch: 'fetchInProcessAll' },
        allScheduled: { pageProp: 'scheduledCurrentPage', fetch: 'fetchScheduledAll' },
        allInLot: { pageProp: 'InLotCurrentPage', fetch: 'fetchInLotAll' },
      },

      username: '',
      firstName: '',
      lastName: '',
      isSuperuser: false,
      groups: [],
      permissions: [],
      insurerServices: [],
      insurerLoading: false,
      insurerPollHandle: null,
      insurerModalOpen: false,
      insurerActionLoading: false,
      insurerRecommendationLoading: false,
      activeInsurerService: null,
      insurerRecommendations: [],
      insurerAssignForm: {
        unit: '',
        operator: '',
        minutosArribo: '',
        rejectReason: 'provider_cancelled',
      },
      insurerResolved: {
        unitName: '',
        operatorName: '',
        unitError: '',
        operatorError: '',
      },
      insurerSeenServiceIds: [],
      insurerToastQueue: [],
      lastInsurerSoundAt: 0,
      insurerCountdownNow: Date.now(),
      insurerCountdownHandle: null,
      insurerTimeoutHandling: false,
      showInsurerValidationModal: false,
      insurerValidationLoading: false,
      insurerValidationUnits: [],
      selectedInsurerValidationUnit: null,
      insurerValidationMap: null,
      insurerValidationOriginMarker: null,
      insurerValidationUnitMarkers: [],
      insurerValidationDirectionsRenderer: null,
      insurerValidationSelectedMarker: null,
      insurerValidationWaypointMarkers: [],
      insurerInlineMap: null,
      insurerInlineOriginMarker: null,
      insurerInlineUnitMarkers: [],
      insurerInlineDirectionsRenderer: null,
      insurerInlineSelectedMarker: null,
      insurerInlineWaypointMarkers: [],
      selectedInsurerInlineUnit: null,
    };
  },
  computed: {
    canViewOperationsTables() {
      return this.hasAnyPerm(['operations.view_assistance_table', 'operations.view_scheduled_table']);
    },
    canSearchAssistanceNotes() {
      return this.hasAnyPerm(['operations.search_assistance_notes']);
    },
    canViewStatusUnits() {
      return this.hasAnyPerm(['operations.view_status_units']);
    },
    canCreateOrder() {
      return this.hasAnyPerm(['operations.create_assistance_note']);
    },
    canViewMainMap() {
      return this.hasAnyPerm(['operations.view_main_map']);
    },
    canViewInsurerInbox() {
      return this.hasAnyPerm(['operations.view_insurer_inbox']);
    },
    insurerCountdown() {
      if (!this.activeInsurerService) return null;
      const deadlineRaw =
        this.activeInsurerService.acceptance_deadline
        || this.activeInsurerService.insurer_payload?.horaMaximaAceptacion;
      if (!deadlineRaw) return null;

      const deadlineMs = new Date(deadlineRaw).getTime();
      if (Number.isNaN(deadlineMs)) return null;

      const remainingMs = Math.max(0, deadlineMs - this.insurerCountdownNow);
      const totalSeconds = Math.floor(remainingMs / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      const label =
        hours > 0
          ? `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
          : `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

      return {
        label,
        seconds: totalSeconds,
        expired: totalSeconds <= 0,
      };
    },
    insurerTimeoutLocked() {
      return Boolean(this.insurerCountdown && this.insurerCountdown.expired);
    },
    totalAssistanceStatusCounts() {
      return Object.values(this.assistanceStatusCounts || {}).reduce((sum, count) => sum + (count || 0), 0);
    },
    totalAuxiliarStatusCounts() {
      return Object.values(this.auxiliarStatusCounts || {}).reduce((sum, count) => sum + (count || 0), 0);
    },
    totalForkliftStatusCounts() {
      return Object.values(this.forkliftStatusCounts || {}).reduce((sum, count) => sum + (count || 0), 0);
    },
    totalIndustrialStatusCounts() {
      return Object.values(this.industrialStatusCounts || {}).reduce((sum, count) => sum + (count || 0), 0);
    },
    totalLotStatusCounts() {
      return Object.values(this.lotStatusCounts || {}).reduce((sum, count) => sum + (count || 0), 0);
    },
    totalAllStatusCounts() {
      return (this.InProgressStatusCounts?.Activo || 0) + (this.InProgressStatusCounts?.Asignada || 0);
    },
    totalScheduledStatusCounts() {
      return Object.values(this.ScheduledStatusCounts || {}).reduce((sum, count) => sum + (count || 0), 0);
    },
    totalInLotStatusCounts() {
      return Object.values(this.inLotStatusCounts || {}).reduce((sum, count) => sum + (count || 0), 0);
    },
    assistancePaginatedInProcessOrders() { return this.assistanceInProcessOrders },
    assistanceTotalInProcessPages() { return Math.ceil((this.assistanceStatusCounts.Activo + this.assistanceStatusCounts.Asignada) / this.assistancePageSize); },
    assistancePaginatedScheduledOrders() { return this.assistanceScheduledOrders },
    assistanceTotalScheduledPages() { return Math.ceil(this.assistanceStatusCounts.Programado/this.assistancePageSizeScheduled) },
    auxiliarPaginatedInProcessOrders() { return this.auxiliarInProcessOrders },
    auxiliarTotalInProcessPages() { return Math.ceil((this.auxiliarStatusCounts.Activo + this.auxiliarStatusCounts.Asignada)/ this.auxiliarPageSize); },
    auxiliarPaginatedScheduledOrders() { return this.auxiliarScheduledOrders },
    auxiliarTotalScheduledPages() { return Math.ceil(this.auxiliarStatusCounts.Programado/this.auxiliarPageSizeScheduled) },
    lotPaginatedInProcessOrders() { return this.lotInProcessOrders },
    lotTotalInProcessPages() { return Math.ceil((this.lotStatusCounts.Activo + this.lotStatusCounts.Asignada) / this.lotPageSize); },
    lotPaginatedScheduledOrders() { return this.lotScheduledOrders },
    lotTotalScheduledPages() { return Math.ceil(this.lotStatusCounts.Programado/this.lotPageSizeScheduled) },
    forkliftPaginatedInProcessOrders() { return this.forkliftInProcessOrders },
    forkliftTotalInProcessPages() { return Math.ceil((this.forkliftStatusCounts.Activo + this.forkliftStatusCounts.Asignada)  / this.forkliftPageSize); },
    forkliftPaginatedScheduledOrders() { return this.forkliftScheduledOrders },
    forkliftTotalScheduledPages() { return Math.ceil(this.forkliftStatusCounts.Programado/this.forkliftPageSizeScheduled) },
    industrialPaginatedInProcessOrders() { return this.industrialInProcessOrders },
    industrialTotalInProcessPages() { return Math.ceil((this.industrialStatusCounts.Activo + this.industrialStatusCounts.Asignada) / this.industrialPageSize); },
    industrialPaginatedScheduledOrders() { return this.industrialScheduledOrders },
    industrialTotalScheduledPages() { return Math.ceil(this.industrialStatusCounts.Programado/this.industrialPageSizeScheduled) },
    allPaginatedInProcessOrders() { return this.InProcessOrders },
    allTotalInProcessPages() { return Math.ceil((this.InProgressStatusCounts.Activo + this.InProgressStatusCounts.Asignada)  / this.InProgressPageSize); },
    allPaginatedScheduledOrders() { return this.scheduledOrders },
    allTotalScheduledPages() { return Math.ceil(this.ScheduledStatusCounts.Programado / this.scheduledPageSize) },
    allPaginatedInLotOrders() { return this.InLotOrders },
    allTotalInLotPages() { return Math.ceil(this.inLotStatusCounts.Programado / this.InLotPageSize) }
  },
  mounted() {
    const savedTab = this.$route.query.tab;
    if (savedTab) {
      this.activeTab = savedTab;
    }
    this.loadPermissions();
    if (!this.canViewOperationsTables) {
      Swal.fire({
        title: 'Sin permisos',
        text: 'No tienes permisos para acceder al módulo de operaciones.',
        icon: 'warning',
        confirmButtonText: 'Ok',
      });
      this.$router.push({ name: 'MainPanel' });
      return;
    }
    this.fetchStatisticsAssistance();
    this.fetchScheduledAssistance(); //called with default arguments 
    this.fetchInProcessAssistance(); //called with default arguments 
    this.fetchStatisticsAuxiliar();
    this.fetchScheduledAuxiliar(); //called with default arguments 
    this.fetchInProcessAuxiliar(); //called with default arguments 
    this.fetchStatisticsLot();
    this.fetchScheduledLot(); //called with default arguments   
    this.fetchInProcessLot(); //called with default arguments 
    this.fetchStatisticsForklift();
    this.fetchScheduledForklift();
    this.fetchInProcessForklift();
    this.fetchStatisticsIndustrial();
    this.fetchScheduledIndustrial();
    this.fetchInProcessIndustrial();
    this.fetchStatisticsAll();
    this.fetchInProcessAll();
    this.fetchScheduledAll();
    this.fetchScheduledStatisticsAll();
    this.fetchInLotAll();
    this.fetchInLotStatistics();
    this.fetchCurrentUser();
    this.fetchInsurerServices();
    this.insurerPollHandle = setInterval(() => {
      this.fetchInsurerServices();
    }, 5000);
  },
  beforeUnmount() {
    if (this.insurerPollHandle) {
      clearInterval(this.insurerPollHandle);
      this.insurerPollHandle = null;
    }
    if (this.insurerCountdownHandle) {
      clearInterval(this.insurerCountdownHandle);
      this.insurerCountdownHandle = null;
    }
    this.closeInsurerValidationModal();
    this.destroyInsurerInlineMap();
    this.$store.commit('setInsurerToastCount', 0);
  },
  watch: {
    insurerToastQueue(queue) {
      // Lets the global chat bubble move out of the toasts' corner.
      this.$store.commit('setInsurerToastCount', queue.length);
    },
    // Whenever tab changes, update URL
    activeTab(newTab) {
      this.$router.replace({ query: { ...this.$route.query, tab: newTab } });
    },
    insurerModalOpen(isOpen) {
      if (isOpen) {
        this.insurerCountdownNow = Date.now();
        if (!this.insurerCountdownHandle) {
          this.insurerCountdownHandle = setInterval(() => {
            this.insurerCountdownNow = Date.now();
          }, 1000);
        }
      } else {
        if (this.insurerCountdownHandle) {
          clearInterval(this.insurerCountdownHandle);
          this.insurerCountdownHandle = null;
        }
        this.closeInsurerValidationModal();
        this.destroyInsurerInlineMap();
      }
    },
    insurerCountdown(nextCountdown) {
      if (!this.insurerModalOpen || !nextCountdown?.expired) return;
      this.handleInsurerTimeout();
    },
  },
  methods: {
    loadPermissions() {
      try {
        const stored = localStorage.getItem('userPermissions');
        this.permissions = stored ? JSON.parse(stored) : [];
      } catch (error) {
        console.error('Error parsing permissions from localStorage:', error);
        this.permissions = [];
      }
    },
    hasPerm(perm) {
      if (this.isSuperuser) {
        return true;
      }
      if (!this.permissions || this.permissions.length === 0) {
        return false;
      }
      return this.permissions.includes(perm) || this.permissions.includes(`access_control.${perm}`);
    },
    hasAnyPerm(perms) {
      if (!perms || perms.length === 0) {
        return true;
      }
      return perms.some((perm) => this.hasPerm(perm));
    },
    containsCancelado(value) {
      if (value === null || value === undefined) return false;
      return /cancelad[oa]/i.test(String(value));
    },
    formatLocationText(location) {
      if (!location) return '';
      if (typeof location === 'string') return location;
      return [location.neighborhood, location.city, location.state]
        .filter((segment) => segment !== null && segment !== undefined && segment !== '')
        .join(' ');
    },
    hasCanceladoInRow(order) {
      const sourceText = this.formatLocationText(order?.source);
      const destinationText = this.formatLocationText(order?.destination);
      return this.containsCancelado(sourceText)
        || this.containsCancelado(destinationText)
        || this.containsCancelado(order?.file_number);
    },
    isInsurerPendingRow(order) {
      return !!order?.insurer_state && order.insurer_state !== 'accepted';
    },
    isOverdueRow(order) {
      // Past-ETA and still no registered arrival → needs attention.
      if (!order?.expected_time || order?.arrival_time) return false;
      const status = order?.status || '';
      if (status === 'Cancelado' || status === 'Completado') return false;
      const requestDate = new Date(order.request_time);
      const expectedDate = new Date(requestDate.getTime() + order.expected_time * 60 * 1000);
      return Date.now() > expectedDate.getTime();
    },
    async maybeOpenInsurerAcceptanceFromNote(notetype, noteID) {
      const apiDirectory = process.env.API_DIRECTORY;
      try {
        const response = await axios.get(
          `${apiDirectory}/insurer/services`,
          {
            params: { note_ident: noteID },
            headers: { Authorization: 'Token ' + localStorage.getItem('authToken') },
          }
        );
        const insurerServices = Array.isArray(response.data) ? response.data : [];
        const related = insurerServices.find((svc) => svc.note_ident === noteID);
        if (!related || related.state === 'accepted') {
          return false;
        }

        const prompt = await Swal.fire({
          title: 'Servicio pendiente de portal',
          text: 'Esta nota proviene de un servicio de portal que aún no ha sido aceptado. ¿Deseas abrir el popup de aceptación?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Abrir aceptación',
          cancelButtonText: 'Cancelar',
        });
        if (!prompt.isConfirmed) return true;

        await this.openInsurerService(related);
        return true;
      } catch (error) {
        console.error('Failed insurer note gate check', error);
        return false;
      }
    },
    viewNoteDetails(notetype, noteID) {
      this.maybeOpenInsurerAcceptanceFromNote(notetype, noteID).then((blocked) => {
        if (blocked) return;
        this.$router.push({
          name: 'EditNote',
          params: { notetype, noteID },
          query: { tab: this.activeTab }, // preserve the tab
        });
      });
    },
    /* ---- sorting helpers ---- */
    orderingFor(tableKey) {
      const s = this.sortState[tableKey];
      if (!s || !s.by) return '';
      return (s.dir === 'desc' ? '-' : '') + s.by;
    },
    isSorted(tableKey, field) {
      const s = this.sortState[tableKey];
      return !!s && s.by === field;
    },
    toggleSort(tableKey, field) {
  const s = this.sortState[tableKey];
  if (!s) return;

  if (s.by === field) {
    s.dir = (s.dir === 'asc') ? 'desc' : 'asc';
  } else {
    s.by = field;
    s.dir = 'asc';
  }

  const cfg = this.tableConfig[tableKey];
  if (!cfg) return;

  this[cfg.pageProp] = 1;

  // 🔧 trigger the refetch with the new ordering
  const fetchFn = this[cfg.fetch];
  if (typeof fetchFn === 'function') fetchFn(1);
},

async fetchCurrentUser() {
      const apiDirectory = process.env.API_DIRECTORY
      this.loading = true
      this.error = null
      try {
        const { data } = await axios.get(`${apiDirectory}/current-user/`, {
          headers: { Authorization: 'Token ' + localStorage.getItem('authToken') },
        })
        this.username = data.username
        this.firstName = data.first_name
        this.lastName = data.last_name
        this.isSuperuser = !!data.is_superuser
        this.groups = data.groups || []
        this.permissions = Array.isArray(data.permissions) ? data.permissions : this.permissions
      } catch (err) {
        console.error('Error fetching user:', err)
        this.error = 'No se pudo cargar la información del usuario.'
      } finally {
        this.loading = false
      }
    },
    getInsurerServiceSummary(service) {
      const payload = service?.insurer_payload || {};
      return `${payload.tipoServicio || 'Servicio'} - ${payload.nombreBeneficiario || 'Sin beneficiario'}`;
    },
    async fetchInsurerServices() {
      const apiDirectory = process.env.API_DIRECTORY;
      this.insurerLoading = true;
      try {
        let response;
        try {
          response = await axios.get(`${apiDirectory}/insurer/services?state=pending`, {
            headers: { Authorization: 'Token ' + localStorage.getItem('authToken') },
          });
        } catch (error) {
          if (error?.response?.status === 403) {
            // Dev bypass: if user lacks insurer-specific perms, still try to fetch to validate popup UX.
            response = await axios.get(`${apiDirectory}/insurer/services`, {
              headers: { Authorization: 'Token ' + localStorage.getItem('authToken') },
            });
          } else {
            throw error;
          }
        }
        const fetched = response.data || [];
        this.insurerServices = fetched;
        const previousIds = new Set(this.insurerSeenServiceIds);
        const currentIds = fetched.map((service) => service.id);
        const newServices = fetched.filter((service) => !previousIds.has(service.id));

        this.insurerSeenServiceIds = currentIds;

        // Keep queue aligned with currently pending services.
        const currentIdSet = new Set(currentIds);
        this.insurerToastQueue = this.insurerToastQueue.filter((svc) => currentIdSet.has(svc.id));

        if (newServices.length > 0) {
          const queuedIdSet = new Set(this.insurerToastQueue.map((svc) => svc.id));
          const uniqueNewServices = newServices.filter((svc) => !queuedIdSet.has(svc.id));
          this.insurerToastQueue = [...uniqueNewServices, ...this.insurerToastQueue].slice(0, 8);
          this.playInsurerNotificationSound();
        }
      } catch (error) {
        console.error('Error fetching insurer services', error);
      } finally {
        this.insurerLoading = false;
      }
    },
    playInsurerNotificationSound() {
      const now = Date.now();
      // Avoid stacking sounds when polls are close together.
      if (now - this.lastInsurerSoundAt < 2500) return;
      this.lastInsurerSoundAt = now;

      try {
        const AudioCtx = window.AudioContext || window.webkitAudioContext;
        if (!AudioCtx) return;
        const context = new AudioCtx();
        const gain = context.createGain();
        gain.gain.setValueAtTime(0.0001, context.currentTime);
        gain.connect(context.destination);

        const pulseTimes = [0, 0.2, 0.4, 0.6, 1.0, 1.2, 1.4, 1.6];
        pulseTimes.forEach((start, idx) => {
          const oscA = context.createOscillator();
          const oscB = context.createOscillator();
          oscA.type = 'square';
          oscB.type = 'square';
          // Alternate tones and layer a second tone for stronger urgency.
          const baseFreq = idx % 2 === 0 ? 1480 : 1040;
          oscA.frequency.setValueAtTime(baseFreq, context.currentTime + start);
          oscB.frequency.setValueAtTime(baseFreq * 1.5, context.currentTime + start);
          oscA.connect(gain);
          oscB.connect(gain);
          oscA.start(context.currentTime + start);
          oscB.start(context.currentTime + start);
          oscA.stop(context.currentTime + start + 0.16);
          oscB.stop(context.currentTime + start + 0.16);
        });

        // Keep intensity constant (no fade-out) until hard stop.
        gain.gain.setValueAtTime(0.26, context.currentTime);

        setTimeout(() => {
          if (context.state !== 'closed') {
            context.close().catch(() => {});
          }
        }, 2200);
      } catch (error) {
        // Browsers may block autoplay audio until user interacts with the page.
        console.debug('Insurer notification sound blocked/unavailable:', error);
      }
    },
    openInsurerToastService(service) {
      if (!service) return;
      this.dismissInsurerToast(service.id);
      this.openInsurerService(service);
    },
    dismissInsurerToast(serviceId) {
      this.insurerToastQueue = this.insurerToastQueue.filter((svc) => svc.id !== serviceId);
    },
    notifyInsurer(icon, title, text = '') {
      return Swal.fire({
        toast: true,
        position: 'top-end',
        icon,
        title,
        text,
        showConfirmButton: false,
        timer: icon === 'error' ? 4000 : 2600,
        timerProgressBar: true,
      });
    },
    async openInsurerService(service) {
      if (!this.canViewInsurerInbox) {
        this.notifyInsurer('warning', 'Sin permisos', 'Puedes ver la notificación en modo prueba, pero necesitas permiso para tomar el servicio.');
        return;
      }
      const apiDirectory = process.env.API_DIRECTORY;
      try {
        const response = await axios.post(
          `${apiDirectory}/insurer/services/${service.id}/claim`,
          {},
          { headers: { Authorization: 'Token ' + localStorage.getItem('authToken') } }
        );
        this.activeInsurerService = response.data.inbox || response.data;
        this.insurerModalOpen = true;
        this.insurerAssignForm = { unit: '', operator: '', minutosArribo: '', rejectReason: 'provider_cancelled' };
        this.insurerResolved = { unitName: '', operatorName: '', unitError: '', operatorError: '' };
        this.insurerRecommendations = [];
        this.destroyInsurerInlineMap();
        this.$nextTick(async () => {
          await this.ensureInsurerGoogleMapsLoaded();
          this.initInsurerInlineMap();
        });
      } catch (error) {
        const statusCode = error?.response?.status;
        if (statusCode === 409) {
          this.notifyInsurer('info', 'Servicio bloqueado', 'Otro usuario ya tomó este servicio.');
          this.fetchInsurerServices();
          return;
        }
        console.error('Error claiming insurer service', error);
        this.notifyInsurer('error', 'Error', 'No se pudo reclamar el servicio.');
      }
    },
    async closeInsurerModalAndRelease() {
      if (this.insurerTimeoutLocked) {
        await this.handleInsurerTimeout();
        return;
      }
      const service = this.activeInsurerService;
      this.insurerModalOpen = false;
      this.activeInsurerService = null;
      this.closeInsurerValidationModal();
      this.destroyInsurerInlineMap();

      if (!service?.id) return;
      if (service.state !== 'claimed' && service.state !== 'pending_sync') return;

      const apiDirectory = process.env.API_DIRECTORY;
      try {
        await axios.post(
          `${apiDirectory}/insurer/services/${service.id}/release`,
          {},
          { headers: { Authorization: 'Token ' + localStorage.getItem('authToken') } }
        );
      } catch (error) {
        // Ignore release failures here; lock enforcement is still server-side.
      } finally {
        this.fetchInsurerServices();
      }
    },
    async handleInsurerTimeout() {
      if (this.insurerTimeoutHandling) return;
      const service = this.activeInsurerService;
      if (!service?.id) return;

      this.insurerTimeoutHandling = true;
      const apiDirectory = process.env.API_DIRECTORY;
      try {
        await axios.post(
          `${apiDirectory}/insurer/services/${service.id}/timeout`,
          {},
          { headers: { Authorization: 'Token ' + localStorage.getItem('authToken') } }
        );
      } catch (error) {
        // 409 means it was already moved out of timeout-eligible state by another flow.
        if (error?.response?.status !== 409) {
          console.error('Failed to timeout insurer service', error);
        }
      } finally {
        this.insurerModalOpen = false;
        this.activeInsurerService = null;
        this.closeInsurerValidationModal();
        this.destroyInsurerInlineMap();
        this.insurerTimeoutHandling = false;
      }

      await this.fetchInsurerServices();
      this.fetchInProcessAssistance();
      this.fetchStatisticsAssistance();
      this.notifyInsurer('warning', 'Tiempo agotado', 'El servicio venció y fue cancelado localmente.');
    },
    async fetchRecommendationsForInsurer() {
      if (!this.activeInsurerService?.note_ident) return;
      const apiDirectory = process.env.API_DIRECTORY;
      this.insurerRecommendationLoading = true;
      try {
        const response = await axios.post(
          `${apiDirectory}/validate-tow`,
          { note_ident: this.activeInsurerService.note_ident },
          { headers: { Authorization: 'Token ' + localStorage.getItem('authToken') } }
        );
        this.insurerRecommendations = (response.data || []).filter((u) => u && u.unit !== 'No disponible');
        this.renderInsurerInlineBestUnits();
      } catch (error) {
        console.error('Failed to fetch insurer recommendations', error);
        this.notifyInsurer('error', 'Error', 'No se pudieron obtener recomendaciones validadas.');
      } finally {
        this.insurerRecommendationLoading = false;
      }
    },
    pickInsurerRecommendation(unit) {
      this.insurerAssignForm.unit = unit || '';
      this.resolveInsurerAssignationInputs();
    },
    ensureInsurerGoogleMapsLoaded() {
      return new Promise((resolve) => {
        if (typeof google !== 'undefined' && google.maps && google.maps.DirectionsService) {
          resolve();
          return;
        }
        const existing = document.getElementById('gmaps-insurer-script');
        if (existing) {
          existing.addEventListener('load', () => resolve());
          return;
        }
        const script = document.createElement('script');
        script.id = 'gmaps-insurer-script';
        const apiKey = 'AIzaSyDttJadFf5cWEcGQMFmRZCrjzUFony74xI';
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
        script.async = true;
        script.defer = true;
        script.onload = () => resolve();
        document.head.appendChild(script);
      });
    },
    getInsurerValidationOriginCoords() {
      const payload = this.activeInsurerService?.insurer_payload || {};
      const lat = Number(payload.latDireccionOrigen);
      const lng = Number(payload.lonDireccionOrigen);
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
      return { lat, lng };
    },
    initInsurerInlineMap() {
      const mapEl = document.getElementById('insurer-inline-validation-map');
      if (!mapEl || typeof google === 'undefined' || !google.maps) return;
      const origin = this.getInsurerValidationOriginCoords();
      if (!origin) return;

      this.insurerInlineMap = new google.maps.Map(mapEl, {
        zoom: 11,
        center: origin,
        mapTypeId: 'roadmap',
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
      });
      this.insurerInlineOriginMarker = new google.maps.Marker({
        position: origin,
        map: this.insurerInlineMap,
        title: 'Origen del servicio',
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          fillColor: '#d32f2f',
          fillOpacity: 1,
          strokeColor: '#ffffff',
          strokeWeight: 2,
          scale: 8,
        },
        zIndex: 9999,
      });
      this.renderInsurerInlineBestUnits();
    },
    renderInsurerInlineBestUnits() {
      if (!this.insurerInlineMap || typeof google === 'undefined' || !google.maps) return;
      this.insurerInlineUnitMarkers.forEach((m) => m.setMap(null));
      this.insurerInlineUnitMarkers = [];
      const origin = this.getInsurerValidationOriginCoords();
      if (!origin) return;

      const bounds = new google.maps.LatLngBounds();
      bounds.extend(origin);
      this.insurerRecommendations
        .filter((u) => u && u.unit !== 'No disponible' && u.lat != null && u.lon != null)
        .slice(0, 5)
        .forEach((unit, idx) => {
          const pos = { lat: Number(unit.lat), lng: Number(unit.lon) };
          if (!Number.isFinite(pos.lat) || !Number.isFinite(pos.lng)) return;
          const marker = new google.maps.Marker({
            position: pos,
            map: this.insurerInlineMap,
            title: `${idx + 1}. ${unit.unit}`,
            label: {
              text: String(idx + 1),
              color: '#ffffff',
              fontSize: '11px',
              fontWeight: 'bold',
            },
            icon: {
              path: google.maps.SymbolPath.CIRCLE,
              fillColor: '#1565c0',
              fillOpacity: 1,
              strokeColor: '#ffffff',
              strokeWeight: 2,
              scale: 10,
            },
          });
          this.insurerInlineUnitMarkers.push(marker);
          bounds.extend(pos);
        });
      if (!bounds.isEmpty()) this.insurerInlineMap.fitBounds(bounds);
    },
    destroyInsurerInlineMap() {
      this.clearInsurerInlineRoute();
      this.insurerInlineUnitMarkers.forEach((m) => m.setMap(null));
      this.insurerInlineUnitMarkers = [];
      if (this.insurerInlineOriginMarker) {
        this.insurerInlineOriginMarker.setMap(null);
        this.insurerInlineOriginMarker = null;
      }
      this.insurerInlineMap = null;
      this.selectedInsurerInlineUnit = null;
    },
    clearInsurerInlineRoute() {
      if (this.insurerInlineDirectionsRenderer) {
        this.insurerInlineDirectionsRenderer.setMap(null);
        this.insurerInlineDirectionsRenderer = null;
      }
      if (this.insurerInlineSelectedMarker) {
        this.insurerInlineSelectedMarker.setMap(null);
        this.insurerInlineSelectedMarker = null;
      }
      if (Array.isArray(this.insurerInlineWaypointMarkers)) {
        this.insurerInlineWaypointMarkers.forEach((m) => m.setMap(null));
      }
      this.insurerInlineWaypointMarkers = [];
    },
    selectInsurerInlineUnit(unit) {
      if (!unit || unit.lat == null || unit.lon == null) return;
      if (!this.insurerInlineMap || typeof google === 'undefined' || !google.maps) return;

      this.selectedInsurerInlineUnit = unit;
      this.pickInsurerRecommendation(unit.unit);
      this.clearInsurerInlineRoute();

      const originCoords = this.getInsurerValidationOriginCoords();
      if (!originCoords) return;
      const unitCoords = { lat: Number(unit.lat), lng: Number(unit.lon) };
      const routeColor = '#2e7d32';

      const isBest = this.insurerRecommendations.slice(0, 5).some((u) => u.unit === unit.unit);
      if (!isBest) {
        this.insurerInlineSelectedMarker = new google.maps.Marker({
          position: unitCoords,
          map: this.insurerInlineMap,
          title: unit.unit,
          icon: {
            path: google.maps.SymbolPath.CIRCLE,
            fillColor: routeColor,
            fillOpacity: 1,
            strokeColor: '#ffffff',
            strokeWeight: 2,
            scale: 11,
          },
          zIndex: 9998,
        });
      }

      const waypoints = this.buildInsurerUnitRouteWaypoints(unit);
      this.insurerInlineWaypointMarkers = [];
      waypoints.forEach((wp, idx) => {
        const marker = new google.maps.Marker({
          position: { lat: wp.lat, lng: wp.lng },
          map: this.insurerInlineMap,
          title: `${wp.kind === 'origin' ? 'Origen' : 'Destino'} de ${wp.note || 'servicio asignado'}`,
          label: {
            text: String(idx + 1),
            color: '#ffffff',
            fontSize: '10px',
            fontWeight: 'bold',
          },
          icon: {
            path: google.maps.SymbolPath.CIRCLE,
            fillColor: '#ef6c00',
            fillOpacity: 1,
            strokeColor: '#ffffff',
            strokeWeight: 2,
            scale: 8,
          },
          zIndex: 9990,
        });
        this.insurerInlineWaypointMarkers.push(marker);
      });

      const directionsService = new google.maps.DirectionsService();
      const renderer = new google.maps.DirectionsRenderer({
        map: this.insurerInlineMap,
        suppressMarkers: true,
        preserveViewport: true,
        polylineOptions: {
          strokeColor: routeColor,
          strokeOpacity: 0.9,
          strokeWeight: 5,
        },
      });
      this.insurerInlineDirectionsRenderer = renderer;
      const selectionToken = unit;
      directionsService.route(
        {
          origin: unitCoords,
          destination: originCoords,
          waypoints: waypoints.map((wp) => ({ location: { lat: wp.lat, lng: wp.lng }, stopover: true })),
          travelMode: google.maps.TravelMode.DRIVING,
        },
        (result, status) => {
          if (this.selectedInsurerInlineUnit !== selectionToken) {
            renderer.setMap(null);
            return;
          }
          if (status === 'OK') {
            renderer.setDirections(result);
          } else {
            renderer.setMap(null);
            const path = [unitCoords, ...waypoints.map((wp) => ({ lat: wp.lat, lng: wp.lng })), originCoords];
            const fallback = new google.maps.Polyline({
              path,
              geodesic: true,
              strokeColor: routeColor,
              strokeOpacity: 0.8,
              strokeWeight: 4,
            });
            fallback.setMap(this.insurerInlineMap);
            this.insurerInlineDirectionsRenderer = fallback;
          }
          const bounds = new google.maps.LatLngBounds();
          bounds.extend(originCoords);
          bounds.extend(unitCoords);
          waypoints.forEach((wp) => bounds.extend({ lat: wp.lat, lng: wp.lng }));
          this.insurerInlineMap.fitBounds(bounds);
        }
      );
    },
    async openInsurerValidationModal() {
      if (!this.activeInsurerService?.note_ident) return;
      this.showInsurerValidationModal = true;
      this.insurerValidationLoading = true;
      this.selectedInsurerValidationUnit = null;
      this.insurerValidationUnits = [];
      try {
        const apiDirectory = process.env.API_DIRECTORY;
        const response = await axios.post(
          `${apiDirectory}/validate-tow`,
          { note_ident: this.activeInsurerService.note_ident },
          { headers: { Authorization: 'Token ' + localStorage.getItem('authToken') } }
        );
        this.insurerValidationUnits = (response.data || []).filter((u) => u && u.unit !== 'No disponible');
        this.insurerValidationLoading = false;
        await this.$nextTick();
        await this.ensureInsurerGoogleMapsLoaded();
        this.initInsurerValidationMap();
      } catch (error) {
        this.insurerValidationLoading = false;
        console.error('Failed to fetch insurer validation units', error);
        this.notifyInsurer('error', 'Error', 'No se pudieron obtener las unidades para validar.');
      }
    },
    closeInsurerValidationModal() {
      this.showInsurerValidationModal = false;
      this.selectedInsurerValidationUnit = null;
      this.clearInsurerValidationRoute();
      if (Array.isArray(this.insurerValidationUnitMarkers)) {
        this.insurerValidationUnitMarkers.forEach((m) => m.setMap(null));
      }
      this.insurerValidationUnitMarkers = [];
      if (this.insurerValidationOriginMarker) {
        this.insurerValidationOriginMarker.setMap(null);
        this.insurerValidationOriginMarker = null;
      }
      this.insurerValidationMap = null;
    },
    buildInsurerUnitRouteWaypoints(unit) {
      const waypoints = [];
      const services = Array.isArray(unit.assigned_services) ? unit.assigned_services : [];
      services.forEach((svc) => {
        if (!svc.has_arrived && svc.source && svc.source.lat != null) {
          waypoints.push({ lat: Number(svc.source.lat), lng: Number(svc.source.lon), kind: 'origin', note: svc.note_ident });
        }
        if (svc.destination && svc.destination.lat != null) {
          waypoints.push({ lat: Number(svc.destination.lat), lng: Number(svc.destination.lon), kind: 'destination', note: svc.note_ident });
        }
      });
      return waypoints;
    },
    initInsurerValidationMap() {
      const mapEl = document.getElementById('insurer-validation-map');
      if (!mapEl || typeof google === 'undefined' || !google.maps) return;
      const originCoords = this.getInsurerValidationOriginCoords();
      if (!originCoords) return;

      this.insurerValidationMap = new google.maps.Map(mapEl, {
        zoom: 11,
        center: originCoords,
        mapTypeId: 'roadmap',
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        styles: [
          { featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] },
          { featureType: 'transit', elementType: 'labels', stylers: [{ visibility: 'off' }] },
        ],
      });
      this.insurerValidationOriginMarker = new google.maps.Marker({
        position: originCoords,
        map: this.insurerValidationMap,
        title: 'Origen del servicio',
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          fillColor: '#d32f2f',
          fillOpacity: 1,
          strokeColor: '#ffffff',
          strokeWeight: 2,
          scale: 9,
        },
        zIndex: 99999,
      });

      const bounds = new google.maps.LatLngBounds();
      bounds.extend(originCoords);
      this.insurerValidationUnitMarkers = [];
      const bestUnits = this.insurerValidationUnits.slice(0, 5);
      bestUnits.forEach((unit, idx) => {
        if (unit.lat == null || unit.lon == null) return;
        const position = { lat: Number(unit.lat), lng: Number(unit.lon) };
        const marker = new google.maps.Marker({
          position,
          map: this.insurerValidationMap,
          title: `${idx + 1}. ${unit.unit}`,
          label: {
            text: String(idx + 1),
            color: '#ffffff',
            fontSize: '11px',
            fontWeight: 'bold',
          },
          icon: {
            path: google.maps.SymbolPath.CIRCLE,
            fillColor: '#1565c0',
            fillOpacity: 1,
            strokeColor: '#ffffff',
            strokeWeight: 2,
            scale: 11,
          },
        });
        marker.addListener('click', () => this.selectInsurerValidationUnit(unit));
        this.insurerValidationUnitMarkers.push(marker);
        bounds.extend(position);
      });
      if (!bounds.isEmpty()) this.insurerValidationMap.fitBounds(bounds);
    },
    clearInsurerValidationRoute() {
      if (this.insurerValidationDirectionsRenderer) {
        this.insurerValidationDirectionsRenderer.setMap(null);
        this.insurerValidationDirectionsRenderer = null;
      }
      if (this.insurerValidationSelectedMarker) {
        this.insurerValidationSelectedMarker.setMap(null);
        this.insurerValidationSelectedMarker = null;
      }
      if (Array.isArray(this.insurerValidationWaypointMarkers)) {
        this.insurerValidationWaypointMarkers.forEach((m) => m.setMap(null));
      }
      this.insurerValidationWaypointMarkers = [];
    },
    selectInsurerValidationUnit(unit) {
      if (!unit || unit.lat == null || unit.lon == null) return;
      if (!this.insurerValidationMap || typeof google === 'undefined' || !google.maps) return;

      this.selectedInsurerValidationUnit = unit;
      this.clearInsurerValidationRoute();

      const originCoords = this.getInsurerValidationOriginCoords();
      if (!originCoords) return;
      const unitCoords = { lat: Number(unit.lat), lng: Number(unit.lon) };
      const routeColor = '#2e7d32';

      const isBest = this.insurerValidationUnits.slice(0, 5).some((u) => u.unit === unit.unit);
      if (!isBest) {
        this.insurerValidationSelectedMarker = new google.maps.Marker({
          position: unitCoords,
          map: this.insurerValidationMap,
          title: unit.unit,
          icon: {
            path: google.maps.SymbolPath.CIRCLE,
            fillColor: routeColor,
            fillOpacity: 1,
            strokeColor: '#ffffff',
            strokeWeight: 2,
            scale: 11,
          },
          zIndex: 99998,
        });
      }

      const waypoints = this.buildInsurerUnitRouteWaypoints(unit);
      this.insurerValidationWaypointMarkers = [];
      waypoints.forEach((wp, idx) => {
        const marker = new google.maps.Marker({
          position: { lat: wp.lat, lng: wp.lng },
          map: this.insurerValidationMap,
          title: `${wp.kind === 'origin' ? 'Origen' : 'Destino'} de ${wp.note || 'servicio asignado'}`,
          label: {
            text: String(idx + 1),
            color: '#ffffff',
            fontSize: '10px',
            fontWeight: 'bold',
          },
          icon: {
            path: google.maps.SymbolPath.CIRCLE,
            fillColor: '#ef6c00',
            fillOpacity: 1,
            strokeColor: '#ffffff',
            strokeWeight: 2,
            scale: 9,
          },
          zIndex: 99990,
        });
        this.insurerValidationWaypointMarkers.push(marker);
      });

      const directionsService = new google.maps.DirectionsService();
      const renderer = new google.maps.DirectionsRenderer({
        map: this.insurerValidationMap,
        suppressMarkers: true,
        preserveViewport: true,
        polylineOptions: {
          strokeColor: routeColor,
          strokeOpacity: 0.9,
          strokeWeight: 5,
        },
      });
      this.insurerValidationDirectionsRenderer = renderer;
      const selectionToken = unit;
      directionsService.route(
        {
          origin: unitCoords,
          destination: originCoords,
          waypoints: waypoints.map((wp) => ({ location: { lat: wp.lat, lng: wp.lng }, stopover: true })),
          travelMode: google.maps.TravelMode.DRIVING,
        },
        (result, status) => {
          if (this.selectedInsurerValidationUnit !== selectionToken) {
            renderer.setMap(null);
            return;
          }
          if (status === 'OK') {
            renderer.setDirections(result);
          } else {
            renderer.setMap(null);
            const path = [unitCoords, ...waypoints.map((wp) => ({ lat: wp.lat, lng: wp.lng })), originCoords];
            const fallback = new google.maps.Polyline({
              path,
              geodesic: true,
              strokeColor: routeColor,
              strokeOpacity: 0.8,
              strokeWeight: 4,
            });
            fallback.setMap(this.insurerValidationMap);
            this.insurerValidationDirectionsRenderer = fallback;
          }
          const bounds = new google.maps.LatLngBounds();
          bounds.extend(originCoords);
          bounds.extend(unitCoords);
          waypoints.forEach((wp) => bounds.extend({ lat: wp.lat, lng: wp.lng }));
          this.insurerValidationMap.fitBounds(bounds);
        }
      );
    },
    async resolveInsurerAssignationInputs() {
      const apiDirectory = process.env.API_DIRECTORY;
      const unitInput = (this.insurerAssignForm.unit || '').trim();
      const operatorInput = (this.insurerAssignForm.operator || '').trim();

      this.insurerResolved = { unitName: '', operatorName: '', unitError: '', operatorError: '' };

      if (!unitInput && !operatorInput) return;

      try {
        const { data } = await axios.post(
          `${apiDirectory}/insurer/services/resolve-assignation`,
          { unit: unitInput, operator: operatorInput },
          { headers: { Authorization: 'Token ' + localStorage.getItem('authToken') } }
        );

        const resolved = data?.resolved || {};
        if (unitInput) {
          if (resolved.unit) {
            const labelParts = [resolved.unit.unit_short_id, resolved.unit.unit_sub_brand, resolved.unit.unit_plates].filter(Boolean);
            this.insurerResolved.unitName = labelParts.join(' · ');
          } else {
            this.insurerResolved.unitError = `Unidad no encontrada: ${unitInput}`;
          }
        }
        if (operatorInput) {
          if (resolved.operator) {
            const op = resolved.operator;
            const fullName = [op.employee_first_name, op.employee_last_name, op.employee_last_name2].filter(Boolean).join(' ');
            this.insurerResolved.operatorName = `${op.employee_ident} · ${fullName}`.trim();
          } else {
            this.insurerResolved.operatorError = `Operador no encontrado: ${operatorInput}`;
          }
        }
      } catch (error) {
        console.error('Failed to resolve insurer assignation inputs', error);
      }
    },
    async acceptInsurerService() {
      if (!this.activeInsurerService) return;
      const apiDirectory = process.env.API_DIRECTORY;
      const unitInput = (this.insurerAssignForm.unit || '').trim();
      const operatorInput = (this.insurerAssignForm.operator || '').trim();
      const minutosArriboInput = Number(this.insurerAssignForm.minutosArribo);
      if (!unitInput || !operatorInput) {
        this.notifyInsurer('warning', 'Datos incompletos', 'Debes capturar número económico (unidad) y número de nómina (operador).');
        return;
      }
      if (
        this.insurerAssignForm.minutosArribo === ''
        || Number.isNaN(minutosArriboInput)
        || minutosArriboInput < 0
      ) {
        this.notifyInsurer('warning', 'Datos incompletos', 'Debes capturar minutos de arribo (0 o mayor).');
        return;
      }
      this.insurerActionLoading = true;
      try {
        await axios.post(
          `${apiDirectory}/insurer/services/${this.activeInsurerService.id}/accept`,
          {
            unit: unitInput,
            operator: operatorInput,
            minutosArribo: Math.trunc(minutosArriboInput),
          },
          { headers: { Authorization: 'Token ' + localStorage.getItem('authToken') } }
        );
        this.insurerModalOpen = false;
        this.activeInsurerService = null;
        await this.fetchInsurerServices();
        this.fetchInProcessAssistance();
        this.fetchStatisticsAssistance();
        this.notifyInsurer('success', 'Aceptado', 'Servicio aceptado y asignado correctamente.');
      } catch (error) {
        console.error('Failed to accept insurer service', error);
        this.notifyInsurer('error', 'Error', 'No se pudo aceptar el servicio.');
      } finally {
        this.insurerActionLoading = false;
      }
    },
    async rejectInsurerService() {
      if (!this.activeInsurerService) return;
      const apiDirectory = process.env.API_DIRECTORY;
      this.insurerActionLoading = true;
      try {
        await axios.post(
          `${apiDirectory}/insurer/services/${this.activeInsurerService.id}/reject`,
          { reason_key: this.insurerAssignForm.rejectReason },
          { headers: { Authorization: 'Token ' + localStorage.getItem('authToken') } }
        );
        this.insurerModalOpen = false;
        this.activeInsurerService = null;
        await this.fetchInsurerServices();
        this.fetchInProcessAssistance();
        this.fetchStatisticsAssistance();
        this.notifyInsurer('success', 'Rechazado', 'Servicio rechazado/cancelado correctamente.');
      } catch (error) {
        console.error('Failed to reject insurer service', error);
        this.notifyInsurer('error', 'Error', 'No se pudo rechazar el servicio.');
      } finally {
        this.insurerActionLoading = false;
      }
    },


    calculateGradient(requestTime, expectedMinutes, arrivalTime) {
      const requestDate = new Date(requestTime);

      if (!expectedMinutes) {
        return '#64748b'; // slate (no data)
      }

      // Once arrival is registered, the clock stops there:
      // the color reflects elapsed time from creation to arrival, not to "now".
      const referenceTime = arrivalTime ? new Date(arrivalTime) : new Date();

      const expectedDate = new Date(requestDate.getTime() + expectedMinutes * 60 * 1000);
      const totalTime = expectedDate - requestDate;
      const elapsedTime = referenceTime - requestDate;

      const percentage = Math.min(Math.max(elapsedTime / totalTime, 0), 1);

      // --- 3 fixed colors (vivid, saturated) ---
      if (percentage < 1/3) {
        return '#16a34a'; // vivid green
      } else if (percentage < 2/3) {
        return '#ea580c'; // vivid orange
      } else {
        return '#dc2626'; // vivid red
      }
    },
    showStatusCountAssistance(status, event) {
      const count = this.assistanceStatusCounts[status];
      this.assistanceHoverStatusCount = `${status}: ${count}`;
      this.hoverStatusCountStyle.top = `${event.clientY}px`;
      this.hoverStatusCountStyle.left = `${event.clientX}px`;
    },
    showStatusCountAuxiliar(status, event) {
      const count = this.auxiliarStatusCounts[status];
      this.auxiliarHoverStatusCount = `${status}: ${count}`;
      this.hoverStatusCountStyle.top = `${event.clientY}px`;
      this.hoverStatusCountStyle.left = `${event.clientX}px`;
    },
    showStatusCountLot(status, event) {
      const count = this.lotStatusCounts[status];
      this.lotHoverStatusCount = `${status}: ${count}`;
      this.hoverStatusCountStyle.top = `${event.clientY}px`;
      this.hoverStatusCountStyle.left = `${event.clientX}px`;
    },
    showStatusCountForklift(status, event) {
      const count = this.forkliftStatusCounts[status];
      this.forkliftHoverStatusCount = `${status}: ${count}`;
      this.forkliftHoverStatusCountStyle.top = `${event.clientY}px`;
      this.forkliftHoverStatusCountStyle.left = `${event.clientX}px`;
    },
    showStatusCountIndustrial(status, event) {
      const count = this.industrialStatusCounts[status];
      this.industrialHoverStatusCount = `${status}: ${count}`;
      this.industrialHoverStatusCountStyle.top = `${event.clientY}px`;
      this.industrialHoverStatusCountStyle.left = `${event.clientX}px`;
    },
    hideStatusCountAssistance() { this.assistanceHoverStatusCount = ''; },
    hideStatusCountAuxiliar() { this.auxiliarHoverStatusCount = ''; },
    hideStatusCountLot() { this.lotHoverStatusCount = ''; },
    hideStatusCountForklift() { this.forkliftHoverStatusCount = ''; },
    hideStatusCountIndustrial() { this.industrialHoverStatusCount = ''; },

    // viewNoteDetails(notetype, noteID) { this.$router.push({ name: 'EditNote', params: { notetype, noteID } }); },
    viewForkliftNoteDetails(noteID) {
      const notetype = "Montacargas";
      this.viewNoteDetails(notetype, noteID);
    },
    viewIndustrialNoteDetails(noteID) {
      const notetype = "Industrial";
      this.viewNoteDetails(notetype, noteID);
    },
    viewScheduledNoteDetails(notetype, scheduledID) { this.$router.push({ name: 'EditScheduledNote', params: { notetype, scheduledID } }); },

    goToPageAssistance(pageNumber) { this.assistanceCurrentPage = pageNumber; const page = this.assistanceCurrentPage; this.fetchInProcessAssistance(page); },
    goToPageAuxiliar(pageNumber) { this.auxiliarCurrentPage = pageNumber; const page = this.auxiliarCurrentPage; this.fetchInProcessAuxiliar(page); },
    goToPageLot(pageNumber) { this.lotCurrentPage = pageNumber; const page = this.lotCurrentPage; this.fetchInProcessLot(page); },
    goToPageForklift(pageNumber) { this.forkliftCurrentPage = pageNumber; const page = this.forkliftCurrentPage; this.fetchInProcessForklift(page); },
    goToPageIndustrial(pageNumber) { this.industrialCurrentPage = pageNumber; const page = this.industrialCurrentPage; this.fetchInProcessIndustrial(page); },
    goToPageAll(pageNumber) { this.InProgressCurrentPage = pageNumber; const page = this.InProgressCurrentPage; this.fetchInProcessAll(page); },
    goToPageScheduled(pageNumber) { this.scheduledCurrentPage = pageNumber; const page = this.scheduledCurrentPage; this.fetchScheduledAll(page); },
    goToPageInLot(pageNumber) { this.inLotCurrentPage = pageNumber; const page = this.inLotCurrentPage; this.fetchInLotAll(page); },
    goToScheduledPageAssistance(pageNumberScheduled) { this.assistanceCurrentScheduledPage = pageNumberScheduled; const page = this.assistanceCurrentScheduledPage; this.fetchScheduledAssistance(page); },
    goToScheduledPageAuxiliar(pageNumberScheduled) { this.auxiliarCurrentScheduledPage = pageNumberScheduled; const page = this.auxiliarCurrentScheduledPage; this.fetchScheduledAuxiliar(page); },
    goToScheduledPageLot(pageNumberScheduled) { this.lotCurrentScheduledPage = pageNumberScheduled; const page = this.lotCurrentScheduledPage; this.fetchScheduledLot(page); },
    goToScheduledPageForklift(pageNumberScheduled) { this.forkliftCurrentScheduledPage = pageNumberScheduled; const page = this.forkliftCurrentScheduledPage; this.fetchScheduledForklift(page); },
    goToScheduledPageIndustrial(pageNumberScheduled) { this.industrialCurrentScheduledPage = pageNumberScheduled; const page = this.industrialCurrentScheduledPage; this.fetchScheduledIndustrial(page); },

    backMainPanel() { window.location.href = '/main-panel'; },
    applyFiltersAssistance() { this.fetchInProcessAssistance(); this.fetchStatisticsAssistance(); },
    applyFiltersAuxiliar() { this.fetchInProcessAuxiliar(); this.fetchStatisticsAuxiliar(); },
    applyFiltersLot() { this.fetchInProcessLot(); this.fetchStatisticsLot(); },
    applyFiltersForklift() { this.fetchInProcessForklift(); this.fetchStatisticsForklift(); },
    applyFiltersIndustrial() { this.fetchInProcessIndustrial(); this.fetchStatisticsIndustrial(); },
    applyFiltersInProgress() { this.fetchInProcessAll(); this.fetchStatisticsAll(); },
    pricesRequests() { window.location.href = '/prices-requests'; },
    newOrder() { window.location.href = '/create-new-order'; },
    rastreoUnidades() { window.location.href = '/main-map' },
    statusUnits() { window.location.href = '/ver-estatus-unidades' },
    globalfilters() {
      if (!this.canSearchAssistanceNotes) {
        Swal.fire({
          title: 'Sin permisos',
          text: 'No tienes permisos para acceder al maestro de búsqueda.',
          icon: 'warning',
          confirmButtonText: 'Ok',
        });
        return;
      }
      window.location.href = '/filtros-globales';
    },
    ordenesLote() {},

    async fetchStatisticsAssistance(){
      let response;
      const apiDirectory = process.env.API_DIRECTORY;
      let request_filters = this.assistanceFilters;
      request_filters.scheduled_orders = 1;
      try{
        response = await axios.post(`${apiDirectory}/get-services-metadata-statistics`,this.assistanceFilters);
        const statusDict = {1:"Activo",2:"Cancelado",3:"Programado",4:"Completado",5:"Asignada"};
        let statusCounts = {"Activo":0,"Cancelado":0,"Programado":0,"Completado":0,"Asignada":0};
        const responseData = response.data;
        responseData.forEach(item => {
          const status = statusDict[item.status];
          const count = item.count;
          statusCounts[status] = count;
        });
        this.assistanceStatusCounts = statusCounts;
      } catch(error){ console.error("There was an error fetching the statistics",error) }
    },
    async fetchStatisticsAuxiliar(){
      let response;
      const apiDirectory = process.env.API_DIRECTORY;
      let request_filters = this.auxiliarFilters;
      request_filters.scheduled_orders = 1;
      try{
        response = await axios.post(`${apiDirectory}/get-services-metadata-statistics`,request_filters)
        const statusDict = {1:"Activo",2:"Cancelado",3:"Programado",4:"Completado",5:"Asignada"};
        let statusCounts = {"Activo":0,"Cancelado":0,"Programado":0,"Completado":0,"Asignada":0};
        response.data.forEach(item => { const status = statusDict[item.status]; const count = item.count; statusCounts[status] = count; });
        this.auxiliarStatusCounts = statusCounts;
      } catch(error){ console.error("There was an error fetching the statistics",error) }
    },
    async fetchStatisticsLot(){
      let response;
      const apiDirectory = process.env.API_DIRECTORY;
      let request_filters = this.lotFilters;
      request_filters.scheduled_orders = 1;
      try{
        response = await axios.post(`${apiDirectory}/get-services-metadata-statistics`,request_filters)
        const statusDict = {1:"Activo",2:"Cancelado",3:"Programado",4:"Completado",5:"Asignada"};
        let statusCounts = {"Activo":0,"Cancelado":0,"Programado":0,"Completado":0,"Asignada":0};
        response.data.forEach(item => { const status = statusDict[item.status]; const count = item.count; statusCounts[status] = count; });
        this.lotStatusCounts = statusCounts;
      } catch(error){ console.error("There was an error fetching the statistics",error) }
    },
    async fetchStatisticsForklift(){
      let response;
      const apiDirectory = process.env.API_DIRECTORY;
      let request_filters = this.forkliftFilters;
      request_filters.scheduled_orders = 1;
      try{
        response = await axios.post(`${apiDirectory}/get-services-metadata-statistics`,request_filters)
        const statusDict = {1:"Activo",2:"Cancelado",3:"Programado",4:"Completado",5:"Asignada"};
        let statusCounts = {"Activo":0,"Cancelado":0,"Programado":0,"Completado":0,"Asignada":0};
        response.data.forEach(item => { const status = statusDict[item.status]; const count = item.count; statusCounts[status] = count; });
        this.forkliftStatusCounts = statusCounts;
      } catch(error){ console.error("There was an error fetching the statistics",error) }
    },
    async fetchStatisticsIndustrial(){
      let response;
      const apiDirectory = process.env.API_DIRECTORY;
      let request_filters = this.industrialFilters;
      request_filters.scheduled_orders = 1;
      try{
        response = await axios.post(`${apiDirectory}/get-services-metadata-statistics`,request_filters)
        const statusDict = {1:"Activo",2:"Cancelado",3:"Programado",4:"Completado",5:"Asignada"};
        let statusCounts = {"Activo":0,"Cancelado":0,"Programado":0,"Completado":0,"Asignada":0};
        response.data.forEach(item => { const status = statusDict[item.status]; const count = item.count; statusCounts[status] = count; });
        this.industrialStatusCounts = statusCounts;
      } catch(error){ console.error("There was an error fetching the statistics",error) }
    },
    async fetchStatisticsAll(){
      let response;
      const apiDirectory = process.env.API_DIRECTORY;
      let request_filters = this.InProgressAllFilters;
      request_filters.scheduled_orders = 1;
      try{
        response = await axios.post(`${apiDirectory}/get-services-metadata-statistics`,this.InProgressAllFilters);
        const statusDict = {1:"Activo",2:"Cancelado",3:"Programado",4:"Completado",5:"Asignada"};
        let statusCounts = {"Activo":0,"Cancelado":0,"Programado":0,"Completado":0,"Asignada":0};
        const responseData = response.data;
        responseData.forEach(item => { const status = statusDict[item.status]; const count = item.count; statusCounts[status] = count; });
        this.InProgressStatusCounts = statusCounts;
      } catch(error){ console.error("There was an error fetching the statistics",error) }
    },

    async fetchScheduledStatisticsAll() {
      const apiDirectory = process.env.API_DIRECTORY;
      try {
        const { data } = await axios.post(
          `${apiDirectory}/get-scheduled-services-metadata-statistics`,
          this.ScheduledAllFilters
        );
        const statusCounts = {"Activo":0,"Cancelado":0,"Programado":0,"Completado":0,"Asignada":0};
        const total = Array.isArray(data) ? data.reduce((sum, row) => sum + (row.count ?? 0), 0) : 0;
        statusCounts["Programado"] = total;
        this.ScheduledStatusCounts = statusCounts;
      } catch (error) {
        console.error("There was an error fetching scheduled statistics", error);
      }
    },

    async fetchInLotStatistics() {
      const apiDirectory = process.env.API_DIRECTORY;
      try {
        const { data } = await axios.post(
          `${apiDirectory}/get-services-metadata-statistics`,
          this.inLotFilters
        );
        const statusCounts = {"Activo":0,"Cancelado":0,"Programado":0,"Completado":0,"Asignada":0};
        const total = Array.isArray(data) ? data.reduce((sum, row) => sum + (row.count ?? 0), 0) : 0;
        statusCounts["Programado"] = total;
        this.inLotStatusCounts = statusCounts;
      } catch (error) {
        console.error("There was an error fetching in_lot statistics", error);
      }
    },

    /* ---------- FETCHES WITH ORDERING APPENDED ---------- */
    async fetchScheduledAssistance(page = 1) {
      let response
      const apiDirectory = process.env.API_DIRECTORY;
      const ordering = this.orderingFor('assistanceScheduled');
      const orderingParam = ordering ? `&ordering=${encodeURIComponent(ordering)}` : '';
      try {
        response = await axios.post(
          `${apiDirectory}/get-services-metadata-filtered?page=${page}&page_size=${this.assistancePageSizeScheduled}${orderingParam}`,
          {"status":["3"], "type":["2"]}
        );
        const responseData = response.data.results.filter(note => note.type === "Asistencia víal");
        responseData.forEach(order => {
          if (!('contact_time' in order) || order.contact_time === null) { order.contact_time = ''; }
          if (!('arrival_time' in order) || order.arrival_time === null) { order.arrival_time = ''; }
          if (!('start_time' in order) || order.start_time === null) { order.start_time = ''; }
          if (!('unit_id' in order) || order.unit_id === null) { order.unit_id = 'N/A'; }
          if (!('operator_first_name' in order) || order.operator_first_name === null) { order.operator_first_name = 'N/A'; }
          if (!('operator_employee_ident' in order) || order.operator_employee_ident === null) { order.operator_employee_ident = 'N/A'; }
        });
        this.assistanceScheduledOrders = responseData
        this.assistance_n_scheduledOrders = responseData.length
        this.assistanceOriginalOrders = [...responseData]
      }
      catch (error) { console.error('Error fetching data from API:', error) }
    },
    async fetchScheduledAuxiliar(page = 1) {
      let response
      const apiDirectory = process.env.API_DIRECTORY;
      const ordering = this.orderingFor('auxiliarScheduled');
      const orderingParam = ordering ? `&ordering=${encodeURIComponent(ordering)}` : '';
      try {
        response = await axios.post(
          `${apiDirectory}/get-services-metadata-filtered?page=${page}&page_size=${this.auxiliarPageSizeScheduled}${orderingParam}`,
          {"status":["3"], "type": ["1"]}
        );
        const responseData = response.data.results.filter(note => note.type === "Auxilio víal");
        responseData.forEach(order => {
          if (!('contact_time' in order) || order.contact_time === null) { order.contact_time = ''; }
          if (!('arrival_time' in order) || order.arrival_time === null) { order.arrival_time = ''; }
          if (!('start_time' in order) || order.start_time === null) { order.start_time = ''; }
          if (!('unit_id' in order) || order.unit_id === null) { order.unit_id = 'N/A'; }
          if (!('operator_first_name' in order) || order.operator_first_name === null) { order.operator_first_name = 'N/A'; }
          if (!('operator_employee_ident' in order) || order.operator_employee_ident === null) { order.operator_employee_ident = 'N/A'; }
        });
        this.auxiliarScheduledOrders = responseData
        this.auxiliar_n_scheduledOrders = responseData.length
        this.auxiliarOriginalOrders = [...responseData]
      }
      catch (error) { console.error('Error fetching data from API:', error) }
    },
    async fetchScheduledLot(page = 1) {
      let response
      const apiDirectory = process.env.API_DIRECTORY;
      const ordering = this.orderingFor('lotScheduled');
      const orderingParam = ordering ? `&ordering=${encodeURIComponent(ordering)}` : '';
      try {
        response = await axios.post(
          `${apiDirectory}/get-services-metadata-filtered?page=${page}&page_size=${this.LotPageSizeScheduled}${orderingParam}`,
          {"status":["3"], "type":["4"]}
        );
        const responseData = response.data.results.filter(note => note.type === "Lote");
        responseData.forEach(order => {
          if (!('contact_time' in order) || order.contact_time === null) { order.contact_time = ''; }
          if (!('arrival_time' in order) || order.arrival_time === null) { order.arrival_time = ''; }
          if (!('start_time' in order) || order.start_time === null) { order.start_time = ''; }
          if (!('unit_id' in order) || order.unit_id === null) { order.unit_id = 'N/A'; }
          if (!('operator_first_name' in order) || order.operator_first_name === null) { order.operator_first_name = 'N/A'; }
          if (!('operator_employee_ident' in order) || order.operator_employee_ident === null) { order.operator_employee_ident = 'N/A'; }
        });
        this.lotScheduledOrders = responseData
        this.lot_n_scheduledOrders = responseData.length
        this.lotOriginalOrders = [...responseData]
      }
      catch (error) { console.error('Error fetching data from API:', error) }
    },
    async fetchScheduledForklift(page = 1) {
      let response
      const apiDirectory = process.env.API_DIRECTORY;
      const ordering = this.orderingFor('forkliftScheduled');
      const orderingParam = ordering ? `&ordering=${encodeURIComponent(ordering)}` : '';
      try {
        response = await axios.post(
          `${apiDirectory}/get-services-metadata-filtered?page=${page}&page_size=${this.forkliftPageSizeScheduled}${orderingParam}`,
          {"status":["3"], "type":["3"]}
        );
        const responseData = response.data.results.filter(note => note.type === "Montacargas");
        responseData.forEach(order => {
          if (!('contact_time' in order) || order.contact_time === null) { order.contact_time = ''; }
          if (!('arrival_time' in order) || order.arrival_time === null) { order.arrival_time = ''; }
          if (!('start_time' in order) || order.start_time === null) { order.start_time = ''; }
          if (!('unit_id' in order) || order.unit_id === null) { order.unit_id = 'N/A'; }
          if (!('operator_first_name' in order) || order.operator_first_name === null) { order.operator_first_name = 'N/A'; }
          if (!('operator_employee_ident' in order) || order.operator_employee_ident === null) { order.operator_employee_ident = 'N/A'; }
        });
        this.forkliftScheduledOrders = responseData
        this.forklift_n_scheduledOrders = responseData.length
        this.forkliftOriginalOrders = [...responseData]
      }
      catch (error) { console.error('Error fetching data from API:', error) }
    },
    async fetchScheduledIndustrial(page = 1) {
      let response
      const apiDirectory = process.env.API_DIRECTORY;
      const ordering = this.orderingFor('industrialScheduled');
      const orderingParam = ordering ? `&ordering=${encodeURIComponent(ordering)}` : '';
      try {
        response = await axios.post(
          `${apiDirectory}/get-services-metadata-filtered?page=${page}&page_size=${this.industrialPageSizeScheduled}${orderingParam}`,
          {"status":["3"], "type":["5"]}
        );
        const responseData = response.data.results.filter(note => note.type === "Industrial");
        responseData.forEach(order => {
          if (!('contact_time' in order) || order.contact_time === null) { order.contact_time = ''; }
          if (!('arrival_time' in order) || order.arrival_time === null) { order.arrival_time = ''; }
          if (!('start_time' in order) || order.start_time === null) { order.start_time = ''; }
          if (!('unit_id' in order) || order.unit_id === null) { order.unit_id = 'N/A'; }
          if (!('operator_first_name' in order) || order.operator_first_name === null) { order.operator_first_name = 'N/A'; }
          if (!('operator_employee_ident' in order) || order.operator_employee_ident === null) { order.operator_employee_ident = 'N/A'; }
        });
        this.industrialScheduledOrders = responseData
        this.industrial_n_scheduledOrders = responseData.length
        this.industrialOriginalOrders = [...responseData]
      }
      catch (error) { console.error('Error fetching data from API:', error) }
    },
    async fetchInProcessAssistance(page = 1) {
      let response
      const apiDirectory = process.env.API_DIRECTORY;
      const ordering = this.orderingFor('assistance');
      const orderingParam = ordering ? `&ordering=${encodeURIComponent(ordering)}` : '';
      try {
        response = await axios.post(
          `${apiDirectory}/get-services-metadata-filtered?page=${page}&page_size=${this.assistancePageSize}${orderingParam}`,
          this.assistanceFilters
        );
        const responseData = response.data.results.filter(note => note.type === "Asistencia víal");
        responseData.forEach(order => {
          if (!('contact_time' in order) || order.contact_time === null) { order.contact_time = ''; }
          if (!('arrival_time' in order) || order.arrival_time === null) { order.arrival_time = ''; }
          if (!('start_time' in order) || order.start_time === null) { order.start_time = ''; }
          if (!('unit_id' in order) || order.unit_id === null) { order.unit_id = 'N/A'; }
          if (!('operator_first_name' in order) || order.operator_first_name === null) { order.operator_first_name = 'N/A'; }
          if (!('operator_employee_ident' in order) || order.operator_employee_ident === null) { order.operator_employee_ident = 'N/A'; }
        });
        this.assistanceInProcessOrders = responseData
        this.assistance_n_inProcessOrders = responseData.length
        this.assistanceOriginalOrders = [...responseData]
      }
      catch (error) { console.error('Error fetching data from API:', error) }
    },
    async fetchInProcessAuxiliar(page = 1) {
      let response
      const apiDirectory = process.env.API_DIRECTORY;
      const ordering = this.orderingFor('auxiliar');
      const orderingParam = ordering ? `&ordering=${encodeURIComponent(ordering)}` : '';
      try {
        response = await axios.post(
          `${apiDirectory}/get-services-metadata-filtered?page=${page}&page_size=${this.auxiliarPageSize}${orderingParam}`,
          this.auxiliarFilters
        );
        const responseData = response.data.results.filter(note => note.type === "Auxilio víal");
        responseData.forEach(order => {
          if (!('contact_time' in order) || order.contact_time === null) { order.contact_time = ''; }
          if (!('arrival_time' in order) || order.arrival_time === null) { order.arrival_time = ''; }
          if (!('start_time' in order) || order.start_time === null) { order.start_time = ''; }
          if (!('unit_id' in order) || order.unit_id === null) { order.unit_id = 'N/A'; }
          if (!('operator_first_name' in order) || order.operator_first_name === null) { order.operator_first_name = 'N/A'; }
          if (!('operator_employee_ident' in order) || order.operator_employee_ident === null) { order.operator_employee_ident = 'N/A'; }
        });
        this.auxiliarInProcessOrders = responseData
        this.auxiliar_n_inProcessOrders = responseData.length
        this.auxiliarOriginalOrders = [...responseData]
      }
      catch (error) { console.error('Error fetching data from API:', error) }
    },
    async fetchInProcessLot(page = 1) {
      let response
      const apiDirectory = process.env.API_DIRECTORY;
      const ordering = this.orderingFor('lot');
      const orderingParam = ordering ? `&ordering=${encodeURIComponent(ordering)}` : '';
      try {
        response = await axios.post(
          `${apiDirectory}/get-services-metadata-filtered?page=${page}&page_size=${this.lotPageSize}${orderingParam}`,
          this.lotFilters
        );
        const responseData = response.data.results.filter(note => note.type === "Lote");
        responseData.forEach(order => {
          if (!('contact_time' in order) || order.contact_time === null) { order.contact_time = ''; }
          if (!('arrival_time' in order) || order.arrival_time === null) { order.arrival_time = ''; }
          if (!('start_time' in order) || order.start_time === null) { order.start_time = ''; }
          if (!('unit_id' in order) || order.unit_id === null) { order.unit_id = 'N/A'; }
          if (!('operator_first_name' in order) || order.operator_first_name === null) { order.operator_first_name = 'N/A'; }
          if (!('operator_employee_ident' in order) || order.operator_employee_ident === null) { order.operator_employee_ident = 'N/A'; }
        });
        this.lotInProcessOrders = responseData
        this.lot_n_inProcessOrders = responseData.length
        this.lotOriginalOrders = [...responseData]
      }
      catch (error) { console.error('Error fetching data from API:', error) }
    },
    async fetchInProcessForklift(page = 1) {
      let response
      const apiDirectory = process.env.API_DIRECTORY;
      const ordering = this.orderingFor('forklift');
      const orderingParam = ordering ? `&ordering=${encodeURIComponent(ordering)}` : '';
      try {
        response = await axios.post(
          `${apiDirectory}/get-services-metadata-filtered?page=${page}&page_size=${this.forkliftPageSize}${orderingParam}`,
          this.forkliftFilters
        );
        const responseData = response.data.results.filter(note => note.type === "Montacargas");
        responseData.forEach(order => {
          if (!('contact_time' in order) || order.contact_time === null) { order.contact_time = ''; }
          if (!('arrival_time' in order) || order.arrival_time === null) { order.arrival_time = ''; }
          if (!('start_time' in order) || order.start_time === null) { order.start_time = ''; }
          if (!('unit_id' in order) || order.unit_id === null) { order.unit_id = 'N/A'; }
          if (!('operator_first_name' in order) || order.operator_first_name === null) { order.operator_first_name = 'N/A'; }
          if (!('operator_employee_ident' in order) || order.operator_employee_ident === null) { order.operator_employee_ident = 'N/A'; }
        });
        this.forkliftInProcessOrders = responseData
        this.forklift_n_inProcessOrders = responseData.length
        this.forkliftOriginalOrders = [...responseData]
      }
      catch (error) { console.error('Error fetching data from API:', error) }
    },
    async fetchInProcessIndustrial(page = 1) {
      let response
      const apiDirectory = process.env.API_DIRECTORY;
      const ordering = this.orderingFor('industrial');
      const orderingParam = ordering ? `&ordering=${encodeURIComponent(ordering)}` : '';
      try {
        response = await axios.post(
          `${apiDirectory}/get-services-metadata-filtered?page=${page}&page_size=${this.industrialPageSize}${orderingParam}`,
          this.industrialFilters
        );
        const responseData = response.data.results.filter(note => note.type === "Industrial");
        responseData.forEach(order => {
          if (!('contact_time' in order) || order.contact_time === null) { order.contact_time = ''; }
          if (!('arrival_time' in order) || order.arrival_time === null) { order.arrival_time = ''; }
          if (!('start_time' in order) || order.start_time === null) { order.start_time = ''; }
          if (!('unit_id' in order) || order.unit_id === null) { order.unit_id = 'N/A'; }
          if (!('operator_first_name' in order) || order.operator_first_name === null) { order.operator_first_name = 'N/A'; }
          if (!('operator_employee_ident' in order) || order.operator_employee_ident === null) { order.operator_employee_ident = 'N/A'; }
        });
        this.industrialInProcessOrders = responseData
        this.industrial_n_inProcessOrders = responseData.length
        this.industrialOriginalOrders = [...responseData]
      }
      catch (error) { console.error('Error fetching data from API:', error) }
    },
    async fetchInProcessAll(page = 1) {
      let response
      const apiDirectory = process.env.API_DIRECTORY;
      const ordering = this.orderingFor('allInProcess');
      const orderingParam = ordering ? `&ordering=${encodeURIComponent(ordering)}` : '';
      try {
        response = await axios.post(
          `${apiDirectory}/get-services-metadata-filtered?page=${page}&page_size=${this.InProgressPageSize}${orderingParam}`,
          this.InProgressAllFilters
        );
        const responseData = response.data.results;
        responseData.forEach(order => {
          if (!('contact_time' in order) || order.contact_time === null) { order.contact_time = ''; }
          if (!('arrival_time' in order) || order.arrival_time === null) { order.arrival_time = ''; }
          if (!('start_time' in order) || order.start_time === null) { order.start_time = ''; }
          if (!('unit_id' in order) || order.unit_id === null) { order.unit_id = 'N/A'; }
          if (!('operator_first_name' in order) || order.operator_first_name === null) { order.operator_first_name = 'N/A'; }
          if (!('operator_employee_ident' in order) || order.operator_employee_ident === null) { order.operator_employee_ident = 'N/A'; }
        });
        this.InProcessOrders = responseData
        this.n_inProcessOrders = response.data.count
        this.OriginalOrders = [...responseData]
      }
      catch (error) { console.error('Error fetching data from API:', error) }
    },
  async fetchInLotAll(page = 1) {
      let response
      const apiDirectory = process.env.API_DIRECTORY;
      const ordering = this.orderingFor('allInLot');
      const orderingParam = ordering ? `&ordering=${encodeURIComponent(ordering)}` : '';
      try {
        response = await axios.post(
          `${apiDirectory}/get-services-metadata-filtered?page=${page}&page_size=${this.InLotPageSize}${orderingParam}`,
          this.inLotFilters
        );
        const responseData = response.data.results;
        console.log('HOLAAAAaa');
        console.log(responseData);
        responseData.forEach(order => {
          if (!('contact_time' in order) || order.contact_time === null) { order.contact_time = ''; }
          if (!('arrival_time' in order) || order.arrival_time === null) { order.arrival_time = ''; }
          if (!('start_time' in order) || order.start_time === null) { order.start_time = ''; }
          if (!('unit_id' in order) || order.unit_id === null) { order.unit_id = 'N/A'; }
          if (!('operator_first_name' in order) || order.operator_first_name === null) { order.operator_first_name = 'N/A'; }
          if (!('operator_employee_ident' in order) || order.operator_employee_ident === null) { order.operator_employee_ident = 'N/A'; }
        });
        this.InLotOrders = responseData
        this.n_inLotOrders = response.data.count
        this.inLotOrders = [...responseData]
      }
      catch (error) { console.error('Error fetching data from API:', error) }
    },

    async fetchScheduledAll(page = 1) {
      const apiDirectory = process.env.API_DIRECTORY;
      const ordering = this.orderingFor('allScheduled');
      const orderingParam = ordering ? `&ordering=${encodeURIComponent(ordering)}` : '';
      try {
        const response = await axios.post(
          `${apiDirectory}/get-scheduled-services-metadata-filtered?page=${page}&page_size=${this.scheduledPageSize}${orderingParam}`,
          this.ScheduledAllFilters
        );
        const responseData = response.data.results;
        responseData.forEach(order => {
          if (!('contact_time' in order) || order.contact_time === null) order.contact_time = '';
          if (!('arrival_time' in order) || order.arrival_time === null) order.arrival_time = '';
          if (!('start_time' in order) || order.start_time === null) order.start_time = '';
          if (!('unit_id' in order) || order.unit_id === null) order.unit_id = 'N/A';
          if (!('operator_first_name' in order) || order.operator_first_name === null) order.operator_first_name = 'N/A';
          if (!('operator_last_name' in order) || order.operator_last_name === null) order.operator_last_name = 'N/A';
          if (!('operator_employee_ident' in order) || order.operator_employee_ident === null) order.operator_employee_ident = 'N/A';
        });
        this.scheduledOrders = responseData;
        this.n_scheduledOrders = response.data.count;
        this.OriginalScheduledOrders = [...responseData];
      } catch (error) {
        console.error('Error fetching scheduled notes:', error);
      }
    },

    nextPageAssistance() { if (this.assistanceCurrentPage < this.assistanceTotalInProcessPages) this.assistanceCurrentPage++; const page = this.assistanceCurrentPage; this.fetchInProcessAssistance(page); },
    nextPageAuxiliar() { if (this.auxiliarCurrentPage < this.auxiliarTotalInProcessPages) this.auxiliarCurrentPage++; const page = this.auxiliarCurrentPage; this.fetchInProcessAuxiliar(page); },
    nextPageLot() { if (this.lotCurrentPage < this.lotTotalInProcessPages) this.lotCurrentPage++; const page = this.lotCurrentPage; this.fetchInProcessLot(page); },
    nextPageForklift() { if (this.forkliftCurrentPage < this.forkliftTotalInProcessPages) this.forkliftCurrentPage++; const page = this.forkliftCurrentPage; this.fetchInProcessForklift(page); },
    nextPageIndustrial() { if (this.industrialCurrentPage < this.industrialTotalInProcessPages) this.industrialCurrentPage++; const page = this.industrialCurrentPage; this.fetchInProcessIndustrial(page); },
    nextPageInProgress() { if (this.InProgressCurrentPage < this.allTotalInProcessPages) this.InProgressCurrentPage++; const page = this.InProgressCurrentPage; this.fetchInProcessAll(page); },
    nextPageInLot() { if (this.inLotCurrentPage < this.allTotalInLotPages) this.inLotCurrentPage++; const page = this.inLotCurrentPage; this.fetchInLotAll(page); },
    nextPageScheduled() { if (this.scheduledCurrentPage < this.allTotalScheduledPages) this.scheduledCurrentPage++; const page = this.scheduledCurrentPage; this.fetchScheduledAll(page); },

    prevPageAssistance() { if (this.assistanceCurrentPage > 1) this.assistanceCurrentPage--; const page = this.assistanceCurrentPage; this.fetchInProcessAssistance(page); },
    prevPageAuxiliar() { if (this.auxiliarCurrentPage > 1) this.auxiliarCurrentPage--; const page = this.auxiliarCurrentPage; this.fetchInProcessAuxiliar(page); },
    prevPageLot() { if (this.lotCurrentPage > 1) this.lotCurrentPage--; const page = this.lotCurrentPage; this.fetchInProcessLot(page); },
    prevPageForklift() { if (this.forkliftCurrentPage > 1) this.forkliftCurrentPage--; const page = this.forkliftCurrentPage; this.fetchInProcessForklift(page); },
    prevPageIndustrial() { if (this.industrialCurrentPage > 1) this.industrialCurrentPage--; const page = this.industrialCurrentPage; this.fetchInProcessIndustrial(page); },
    prevPageInProgress() { if (this.InProgressCurrentPage > 1) this.InProgressCurrentPage--; const page = this.InProgressCurrentPage; this.fetchInProcessAll(page); },
    prevPageInLot() { if (this.inLotCurrentPage > 1) this.inLotCurrentPage--; const page = this.inLotCurrentPage; this.fetchInLotAll(page); },
    prevPageSceduled() { if (this.scheduledCurrentPage > 1) this.scheduledCurrentPage--; const page = this.scheduledCurrentPage; this.fetchScheduledAll(page); },

    nextScheduledPageAssistance() { if (this.assistanceCurrentScheduledPage < this.assistanceTotalScheduledPages) this.assistanceCurrentScheduledPage++; const page = this.assistanceCurrentScheduledPage; this.fetchScheduledAssistance(page); },
    nextScheduledPageAuxiliar() { if (this.auxiliarCurrentScheduledPage < this.auxiliarTotalScheduledPages) this.auxiliarCurrentScheduledPage++; const page = this.auxiliarCurrentScheduledPage; this.fetchScheduledAuxiliar(page); },
    nextScheduledPageLot() { if (this.lotCurrentScheduledPage < this.lotTotalScheduledPages) this.lotCurrentScheduledPage++; const page = this.lotCurrentScheduledPage; this.fetchScheduledLot(page); },
    nextScheduledPageForklift() { if (this.forkliftCurrentScheduledPage < this.forkliftTotalScheduledPages) this.forkliftCurrentScheduledPage++; const page = this.forkliftCurrentScheduledPage; this.fetchScheduledForklift(page); },
    nextScheduledPageIndustrial() { if (this.industrialCurrentScheduledPage < this.industrialTotalScheduledPages) this.industrialCurrentScheduledPage++; const page = this.industrialCurrentScheduledPage; this.fetchScheduledIndustrial(page); },
    prevScheduledPageAssistance() { if (this.assistanceCurrentScheduledPage > 1) this.assistanceCurrentScheduledPage--; const page = this.assistanceCurrentScheduledPage; this.fetchScheduledAssistance(page); },
    prevScheduledPageAuxiliar() { if (this.auxiliarCurrentScheduledPage > 1) this.auxiliarCurrentScheduledPage--; const page = this.auxiliarCurrentScheduledPage; this.fetchScheduledAuxiliar(page); },
    prevScheduledPageLot() { if (this.lotCurrentScheduledPage > 1) this.lotCurrentScheduledPage--; const page = this.lotCurrentScheduledPage; this.fetchScheduledLot(page); },
    prevScheduledPageForklift() { if (this.forkliftCurrentScheduledPage > 1) this.forkliftCurrentScheduledPage--; const page = this.forkliftCurrentScheduledPage; this.fetchScheduledForklift(page); },
    prevScheduledPageIndustrial() { if (this.industrialCurrentScheduledPage > 1) this.industrialCurrentScheduledPage--; const page = this.industrialCurrentScheduledPage; this.fetchScheduledIndustrial(page); },
  }
}
</script>
